export const TRANSLATIONS_HE = {
  CameraErrorPopup: {
    InfoErrors: {
      deviceInUse:
        '<div>אין גישה למצלמה. </div><div>אפליקציה אחרת משתמשת במצלמה שלך. </div><div>יש לפנות את המצלמה ולנסות שוב. </div>',
      deviceNotFound:
        '<div>לא נמצאה מצלמת רשת. </div><div> נא לוודא שמצלמה כלשהי מחוברת למחשב שלך ופועלת כראוי. </div>',
      failedToAccessTheDevice:
        '<div>אירעה שגיאה בעת ניסיון לגשת למצלמה. </div><div>נא לנסות שוב. </div>',
    },
    InfoGuide: {
      android:
        "<ol>\n      <li>יש לעבור אל <b>Settings</b> > <b>Apps</b> > ולבחור את הדפדפן שלך (Chrome, Firefox וכו'). </li>\n      <li>להקיש על <b>Permissions</b>.</li>\n      <li>להקיש על <b>Camera</b> ולבחור<b> <b>Allow while using the app</b> או <b>Ask every time</b>.</li>\n    </ol>",
      chrome:
        '<ol>\n      <li>יש ללחוץ על סמל <b>ההגדרות</b> בשורת הכתובת.</li>\n      <li>לבחור <b>"Site settings"</b>.</li>\n      <li>לחפש את השורה <b>Camera</b> ולבחור <b>Allow</b> מהרשימה הנפתחת.</li>\n    </ol>',
      default: '<ol><li>יש לפתוח את הגדרות הדפדפן.</li><li> אחר כך להפעיל את המצלמה.</li></ol>',
      edge: '<ol>\n      <li>יש ללחוץ על סמל <b>ההגדרות</b> בשורת הכתובת.</li>\n      <li>לבחור <b>Permissions</b> עבור אתר זה.</li>\n      <li>מתחת לכותרת <b>Camera</b>, לבחור <b>Allow</b>.</li>\n    </ol>',
      firefox:
        '<ol>\n      <li>יש ללחוץ על סמל <b>ההגדרות</b>  שליד כתובת האתר.</li>     \n <li>ללחוץ על <b>"Permissions"</b>.</li>\n      <li>יש לוודא שהסעיף <b>"Use the Camera"</b> מוגדר כ-Allow.</li>\n    </ol>',
      ios: '<ol>\n      <li>יש לעבור אל <b>Settings</b> > <b>Privacy & Security</b> > <b>Camera</b>.</li>\n      <li>להפעיל <b>on</b> את המתג של הדפדפן שלך (לדוגמה, Safari, Chrome).</li>\n      <li>אם הדפדפן הוא Safari,  יש להקיש על <b>"Allow"</b> כאשר תופיע בקשה להרשאת מצלמה.</li>\n    </ol>',
      safari:
        '<ol>\n      <li>יש לעבור אל ההגדרות של <b>Safari</b> > <b> עבור אתר אינטרנט זה</b>.</li>\n      <li>לצד <b>Camera</b>, יש לבחור <b>Allow</b>.</li>\n</ol>',
    },
    description: 'כדי להתחיל שיחת וידאו עם המורה הפרטי שלך, יש לאפשר גישה למצלמה בדפדפן שלך',
    resolvedBtn: 'בסדר, שיניתי את ההגדרות!',
    skipBtn: 'המשך ללא מצלמה',
    title: 'אנחנו רוצים לראות אותך!',
  },
  ChooseAnotherLevel: 'בחירת רמה אחרת',
  CommunicationProblemModalDescription:
    'השרתים שלנו אינם מגיבים. נא לנסות שוב. <br />אם הבעיה תימשך, נא ליצור איתנו קשר בכתובת info@eb.com',
  CommunicationProblemModalTitle: 'אופס! הייתה לנו בעיה טכנית.',
  GoogleLoginProblemDescription:
    'על המורה שלך לרשום אותך ואת הכיתה שלך לפני שיתאפשר לך להתחיל. לאחר שהמורה שלך ירשום את הכיתה שלך, יתאפשר לך להתחיל את מסע הלימוד שלך עם Hello!',
  GoogleLoginProblemTitle: 'אופס, הייתה לנו בעיה',
  IAlreadyHaveAnAccount: 'כבר יש לי חשבון',
  MicrophoneInfoErrors: {
    deviceInUse:
      '<div>אין גישה למיקרופון. </div><div>אפליקציה אחרת משתמשת במיקרופון שלך. </div><div>יש לפנות את המיקרופון ולנסות שוב. </div>',
    deviceNotFound:
      '<div>לא נמצא מיקרופון. </div><div> נא לוודא שמיקרופון כלשהו מחובר למחשב שלך ופועל כראוי. </div>',
    failedToAccessTheDevice:
      '<div>אירעה שגיאה בעת ניסיון לגשת למיקרופון. </div><div>נא לנסות שוב. </div>',
  },
  MicrophoneInfoGuide: {
    android:
      "<ol>\n      <li>יש לעבור אל <b>Settings</b> > <b>Apps</b> > ולבחור את הדפדפן שלך (Chrome, Firefox וכו'). </li>\n      <li>להקיש על <b>Permissions</b>.</li>\n      <li>להקיש על <b>Microphone</b> ולבחור<b> <b>Allow while using the app</b> או <b>Ask every time</b>.</li>\n    </ol>",
    chrome:
      '<ol>\n      <li>יש ללחוץ על סמל <b>ההגדרות</b> בשורת הכתובת.</li>\n      <li>לבחור <b>"Site settings"</b>.</li>\n      <li>לחפש את השורה <b>Microphone</b> ולבחור <b>Allow</b> מהרשימה הנפתחת.</li>\n    </ol>',
    default:
      '<ol>\n      <li>יש לעבור להגדרות הדפדפן. </li>\n      <li>יש להפעיל את המיקרופון. </li>\n    </ol>',
    edge: '<ol>\n      <li>יש ללחוץ על הסמל <b>settings</b> בשורת הכתובת.</li>\n      <li>לבחור <b>Permissions</b> עבור אתר זה.</li>\n      <li>מתחת לכותרת <b>Microphone</b>, לבחור <b>Allow</b>.</li>\n    </ol>',
    firefox:
      '<ol>\n      <li>יש ללחוץ על הסמל <b>settings</b> שליד כתובת האתר.</li>     \n <li>ללחוץ על <b>"Permissions"</b>.</li>\n      <li>יש לוודא שהסעיף <b>"Use the Microphone"</b> מוגדר כ-Allow.</li>\n    </ol>',
    ios: '<ol>\n      <li>יש לעבור אל <b>Settings</b> > <b>Privacy & Security</b> > <b>Microphone</b>.</li>\n      <li>להפעיל <b>on</b> את המתג של הדפדפן שלך (לדוגמה, Safari, Chrome).</li>\n      <li>אם הדפדפן הוא Safari,  יש להקיש על <b>"Allow"</b> כאשר תופיע בקשה להרשאת מיקרופון.</li>\n    </ol>',
    safari:
      '<ol>\n      <li>יש לעבור אל ההגדרות של <b>Safari</b> > <b> עבור אתר אינטרנט זה</b>.</li>\n      <li>לצד <b>Microphone</b>, יש לבחור <b>Allow</b>.</li>\n</ol>',
  },
  MicrophoneInfoInOrderTo: 'נא לאשר שימוש במיקרופון בדפדפן שלך בשביל חלק מהפעילויות',
  MicrophoneInfoInOrderToQuiz: 'כדי להתחיל לדבר, נא לאפשר גישה למיקרופון.',
  MicrophoneInfoWeWantTo: 'אנחנו רוצים לשמוע אותך!',
  MinasLoginProblemDescription:
    'כתובת דוא"ל זו אינה מורשית להתחבר ל-Hello Britannica. נא ליצור קשר עם המורה או עם הנהלת בית הספר שלך.',
  UnauthorizedLoginProblemDescription:
    'כתובת דוא"ל זו אינה מורשית להתחבר ל-Hello Britannica. נא ליצור קשר עם המורה או עם הנהלת בית הספר שלך.',
  UserNotConfirmedException: 'החשבון שלך לא מאומת. נא להזין את קוד האימות שנשלח למייל שלך.',
  about: 'About',
  accountVerifiedCanLoginNow: 'החשבון שלך אומת, עכשיו אפשר להתחבר',
  accountVerifiedSigningIn: 'Your account is verified. Signing you in…',
  account_settings: 'הגדרות חשבון',
  achievmentsSection: {
    feedback: 'הפגנת יכולות מרשימות!',
    weeklyAchievement: 'ההישג של השבוע',
  },
  active: 'במצב פעיל',
  activities: 'פעילויות',
  addNewClass: 'הוספת כיתה חדשה',
  addYourClasses: 'הוספת הכיתות שלך',
  admin: {
    accountDetailsPage: {
      accountIdRequired: 'Account ID is required for update',
      accountNotFound: 'Account not found.',
      back: 'Back',
      editAccount: 'Edit Account',
      failedToLoad: 'Failed to load account details',
      failedToUpdate: 'Failed to update account',
      loadingAccountDetails: 'Loading account details...',
    },
    accountInfoCard: {
      accountType: 'Account Type',
      brazil: 'Brazil',
      country: 'Country',
      createSchoolHint: 'Click here to create a school and onboard users to Hello.',
      creationDate: 'Creation Date',
      customerPilot: 'Customer Pilot',
      customerProduction: 'Customer Production',
      expirationDate: 'Expiration Date',
      here: 'here',
      learningLanguage: 'Learning Language',
      licensesRemaining: 'Licenses Remaining',
      loginProvider: 'Login Provider',
      nativeLanguage: 'Native Language',
      no: 'No',
      noOfDistricts: 'No. of Districts',
      noOfSchools: 'No. of Schools',
      notSet: 'Not set',
      registeredUsers: 'Registered Users',
      signInOptions: 'Sign In Options',
      systemType: 'System Type',
      tutorActive: 'Tutor Active',
      tutorType: 'Tutor Type',
      userLimit: 'User Limit',
      yes: 'Yes',
    },
    accountsListPage: {
      createNewAccount: '+ Create New Account',
      newAccount: 'New Account',
      title: 'Accounts',
    },
    bimloaFilter: {
      choose: 'Choose',
      chooseDate: 'Choose Date',
      chooseDateRange: 'Choose Date Range',
      failedToFetchSuggestions: 'Failed to fetch suggestions',
      failedToLoadSuggestions: 'Failed to load suggestions',
      last30Days: 'Last 30 days',
      last7Days: 'Last 7 days',
      range: 'Range',
      specificDate: 'Specific date',
    },
    bulkActions: {
      changeLevel: {
        chooseLevel: {
          description:
            "Change the level of {{count}} students to a new level. <b>Changing students' level will reset their scores and progress. Any previous data will be lost.</b> Note that if students are at different levels, proceeding will set all of them to the new level.",
          hasNonActivedStudentsNote:
            'Note: non-active students will not be affected by the level change.',
          level: 'Level',
          mixedLevelsWarning:
            'ℹ️ The selected students are at different levels. Proceeding will set all of them to {{newLevel}}.',
          selectLevel: 'Select a Level',
          submitButton: 'Confirm Change',
          theNewLevel: 'the new level',
          title: "Change Students' level",
        },
        currentLevel: 'Current Level',
        failure: {
          description: 'Please try again.',
          title: 'No students could be updated.',
        },
        partialSuccesses: {
          description:
            '{{completed}} of {{total}} students have been successfully moved to {{newLevel}}. The following students could not be updated:',
        },
        report: {
          actionChangeLevel: 'Change Level',
          class: 'Class',
          fileName: 'Bulk Change Level Report',
          newLevel: 'New Level',
          previousLevel: 'Previous Level',
        },
        successes: {
          title: 'All {{count}} students have been successfully moved to {{newLevel}}.',
        },
      },
      classes: {
        classesSelected_one: '1 Class Selected',
        classesSelected_other: '{{count}} Classes Selected',
        deleteClasses_one: 'Delete Class',
        deleteClasses_other: 'Delete Classes',
      },
      common: {
        action: 'Action',
        classAndGrade: 'Class & Grade',
        failureDescription: 'Please try again later.',
        failureTitle: 'We had a problem',
        name: 'Name',
        partialSuccessTitle: '⚠️ Partial Success',
        teacher: 'Teacher',
      },
      deleteClasses: {
        apiReason: 'Bulk class deletion from school admin',
        confirm: {
          deleteAnywayButton: 'Delete Classes',
          titleWithStudents: 'Are you sure?',
          understandWithStudents:
            'I understand that these students and their progress will be permanently deleted.',
          warningEmpty:
            'Are you sure you want to delete these classes? This action cannot be undone.',
          warningWithStudents:
            "You're about to delete {{classCount}} classes containing {{studentCount}} selected students. Deleting these classes will also delete these students and will permanently remove them from the platform. They will no longer be able to log in and their progress data will be lost. Once confirmed, this action cannot be undone.",
        },
        partialSuccesses: {
          description: 'Some classes could not be deleted. See the table below.',
          statusColumn: 'Status',
          statusDeleted: 'Classes Deleted',
          statusFailed: 'Deleting failed.',
          studentsDeletedRatio: '{{deleted}}/{{total}}',
          tableStudentsDeleted: 'Students Deleted',
        },
        report: {
          actionDelete: 'Delete',
          className: 'Class Name',
          fileName: 'Bulk Delete Classes Report',
          statusFailure: 'Failure',
          statusSuccess: 'Success',
        },
        successes: {
          studentsDeletedFollowUpPlural:
            'Also, {{count}} students have been successfully deleted. Deleted students have been logged out of any active sessions and will not be able to log in again.',
          studentsDeletedFollowUpSingular:
            'Also, 1 student has been successfully deleted. The student has been logged out of any active sessions and will not be able to log in again.',
          title: 'The selected classes have been successfully deleted!',
        },
      },
      deleteStudents: {
        chooseReason: {
          confirmationCheckbox:
            'I understand that these students and their progress will be permanently deleted.',
          description:
            'You’re about to delete {{num}} selected students. Deleting these students will permanently remove them from the platform. They will no longer be able to log in and their progress data will be lost. Once confirmed, this action cannot be undone.',
          reason: 'Reason',
          subDescription: 'This helps us track why students are removed from the platform.',
          subTitle: 'Please provide a reason.',
          submitButton: 'Delete Students',
          title: 'Are you sure?',
          why: 'Why?',
        },
        partialSuccesses: {
          description:
            'Deleted students have been logged out of any active sessions and will not be able to log in again.',
        },
        report: {
          class: 'Class',
          fileName: 'Bulk Delete Students Report',
        },
        successes: {
          description:
            'Deleted students have been logged out of any active sessions and will not be able to log in again.',
          title: 'The selected students have been successfully deleted!',
        },
      },
      downloadChanges: {
        downloadButton: 'Download',
        text: 'a list of the changes',
      },
      moveStudents: {
        availableSeats: {
          description:
            'You selected {{selectedCount}} students, but only {{availableSeats}} seats are available in {{destinationClass}}.\nPlease choose a different class or select fewer students.',
          title: '⚠️ This class doesn’t have enough available seats.',
        },
        chooseDestination: {
          description:
            'Move {{num}} selected students to a new class. Student progress, login history, and scores will be preserved.',
          full: 'Full',
          selectClass: 'Select a Class',
          spotsLeft: '{{num}} spots left',
          subDescription:
            'Student progress, login history, and scores will be preserved during the move.',
          subTitle: 'Choose Destination',
          submitButton: 'Move Students',
          title: 'Move Students',
        },
        differentGrade: {
          description:
            'One or more selected students are currently assigned to a class in a different grade than the destination class.',
          moveAllButton: 'Move anyway',
          moveSameButton: 'Move without these students',
          title: '⚠️ Some students are in a different grade.',
        },
        partialSuccesses: {
          description: 'Students who could not be moved still belong to their original class. ',
        },
        report: {
          actionMove: 'Move',
          fileName: 'Bulk Move Students Report',
          moveFromClass: 'Move from Class',
          moveFromGrade: 'Move from Grade',
          moveFromTeacher: 'Move from Teacher',
          moveToClass: 'Move to Class',
          moveToGrade: 'Move to Grade',
          moveToTeacher: 'Move to Teacher',
        },
        studentsTable: {
          currentClassAndGrade: 'Current Class & Grade',
          destinationClassAndGrade: 'Destination Class & Grade',
        },
        successes: {
          description: 'Student progress, login history, and scores will be preserved.',
          title: 'The selected students have been successfully moved!',
        },
      },
    },
    changePassword: {
      changePassword: 'Change Password',
      confirmPassword: 'Confirm Password',
      currentPassword: 'Current Password',
      invalidPassword: 'Invalid password',
      newPassword: 'New Password',
      password: 'Password',
      passwordsDontMatch: 'Passwords don’t match',
      reEnterNewPassword: 'Re-Enter New Password',
      requirements: 'Requirements:',
    },
    classCodeModal: {
      copyClassCode: 'Copy Code',
      copyClassCodeDescription:
        'Copy the code and send it to your students so they can join the platform!',
      yourClassCode: 'Your Class Code:',
    },
    cognitoErrors: {
      NetworkError: 'Network error. Please check your internet connection and try again.',
      invalidUsernameOrPassword: 'Invalid email or password',
    },
    collapseSidebar: 'Collapse sidebar',
    comingSoon: 'Coming Soon',
    common: {
      back: 'Back',
      cancel: 'Cancel',
      copied: 'Copied!',
      loading: 'Loading...',
      save: 'Save',
      saving: 'Saving...',
      search: 'Search',
      tabs: {
        classes: 'Classes',
        general: 'General Details',
        students: 'Students',
        teachers: 'Teachers',
      },
      tryAgain: 'Try Again',
      tryAgainLater: 'Please try again later.',
    },
    desktopOnlyMessage:
      'To watch your school’s details, reports and dashboards, please use the desktop version.',
    dir: 'rtl',
    districtDetailsPage: {
      back: 'Back',
      editDistrict: 'Edit District',
      info: {
        country: 'Country',
        creationDate: 'Creation Date',
        email: 'Email',
        expirationDate: 'Expiration Date',
        location: 'Location',
        manager: 'Manager',
        nativeLanguage: 'Native Language',
        numSchools: 'No. of Schools',
        numSchoolsHint: 'At least one school must be linked for platform use.',
        registeredUsers: 'Registered Users',
      },
      notFound: 'District not found.',
      schoolsTable: {
        addNew: '+ Add New',
        columns: {
          contact: 'Contact',
          school: 'School',
          students: 'Students',
          teachers: 'Number of Teachers',
        },
        title: 'Schools',
      },
    },
    districtsListPage: {
      columns: {
        activeUsers: 'Active Users',
        admin: 'District Admin',
        adminEmail: 'District Admin Email',
        district: 'District',
        registeredUsers: 'Registered Users',
        status: 'Status',
      },
      filters: {
        admin: 'District Admin',
        adminEmail: 'District Admin Email',
        district: 'District',
        schools: 'Schools',
      },
      newDistricts: 'New Districts',
      title: 'Districts',
    },
    districtsTable: {
      addNew: '+ Add New District',
      columns: {
        contact: 'Contact',
        district: 'District',
        schools: 'No. of Schools',
        users: 'Users',
      },
      noResults: 'There are no Districts created in this deal.',
    },
    download: 'Download',
    downloadAndView: 'Download and View',
    dropDown: {
      placeholder: 'Choose',
    },
    dynamicForm: {
      notification: {
        classCreated: 'The class has been successfully created.',
        classEdited: 'The class has been successfully edited.',
        generalError: 'Error occurred, please try again later',
        schoolNameUpdated: 'The school’s name has been successfully edited',
        studentDeleted: 'The student has been successfully deleted.',
        teacherDeleted: 'The teacher has been successfully deleted.',
        teacherEdited: 'The teacher has been successfully edited.',
      },
      popups: {
        changeStatus: {
          cancel: 'No, Keep Current',
          confirm: 'Yes, Change',
          subTitle: 'Are you sure you want to change the status? This action cannot be undone.',
          title: 'Change Status?',
        },
        editSchoolName: {
          Subtitles: 'Enter the name of the school.',
          label: 'New Name',
          ok: 'Change Name',
          title: 'Change School Name',
        },
        newAccount: {
          cancel: 'Cancel',
          confirm: 'I Agree',
          subTitle:
            'By creating this account, you agree to our terms and conditions for account management and user data handling.',
          title: 'Terms & Conditions',
        },
        newClassMessage: {
          Subtitles:
            'Your students have been emailed instructions for resetting their password. Once your students log in, they will receive a Level Test. Based on the results, they will be placed at their appropriate level and may begin their learning journey.',
          title: 'The class has been created successfully!',
        },
        newRegion: {
          ok: 'OK',
          subTitle:
            '%region admin first and last name% has been sent an email and temporary password with login instructions to HelloHub.',
          title: '%regionName% has been successfully created.',
        },
        newTeacherMessage: {
          Subtitles:
            'Your teachers have been emailed instructions for resetting their password. Once they have done so, they may begin using Hello Britannica.',
          title: 'The teachers have been added successfully!',
        },
        saved: {
          subTitle: 'Your changes have been saved!',
          title: 'Saved!',
        },
        turnOffDeal: {
          keepOn: 'No, Keep it On',
          subTitle: 'Are you sure you want to turn off this deal? This action cannot be undone.',
          title: 'Turn Off Deal?',
          turnOff: 'Yes, Turn Off',
        },
      },
      validation: {
        email: 'Please enter a valid email address.',
        invalidFormat: 'This field contains invalid characters.',
        max: 'Maximum value is {{value}}',
        maxLength: 'Maximum length is {{length}}',
        min: 'Minimum value is {{value}}',
        minLength: 'Minimum length is {{length}}',
        required: 'This field is required',
      },
    },
    error: {
      description: 'We encountered an error while processing your request. Please try again later.',
    },
    expandSidebar: 'Expand sidebar',
    form: {
      editTeacher: 'Edit Teacher',
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
    },
    genericTable: {
      classes: {
        activeStudents: 'Active Students',
        coTeacher: 'Co-Teacher',
        grade: 'Grade',
        name: 'Class Name',
        students: 'Students',
        teacher: 'Teacher Name',
      },
      clearSearch: 'Clear Search',
      clearSelection: 'Clear Selection',
      downloadAriaLabel: 'Download',
      noRecords: 'There are no records to display.',
      noResultsForSearchQuery: 'No search results found for “{{searchQuery}}”',
      searchDescription_one: '{{count}} result found for “{{searchQuery}}”',
      searchDescription_other: '{{count}} results found for “{{searchQuery}}”',
      teachers: {
        activeStudents: 'Active Students',
        firstLogin: 'First Login',
        lastLogin: 'Last Login',
        name: 'Name',
        numClasses: 'Classes',
        numStudents: 'Students',
      },
    },
    gradeLabel: 'Grade',
    historyPage: {
      dealNameLabel: 'deal name:',
      failedToLoad: 'Failed to load history data. Please try again later.',
      filters: {
        action: 'Action',
        date: 'Date',
        dealName: 'Account Name',
        dealType: 'Account Type',
        language: 'Language',
        lms: 'LMS',
      },
      title: 'History',
    },
    instructions: 'Instructions',
    lang: 'he',
    loginPage: {
      back: 'Back',
      changePasswordForm: {
        confirmPassword: 'Confirm Password',
        description: 'Please choose your own password',
        errors: {
          confirmPasswordDontMatch: 'Passwords don’t match',
          confirmPasswordIsRequired: 'Confirm password is required',
        },
        loadingText: '',
        password: 'Password',
        passwordChangedSuccessfully: 'Password changed successfully',
        passwordPlaceholder: 'Password',
        submit: 'Done',
        titel: 'Welcome!',
      },
      forgotPasswordForm: {
        confirmPassword: 'Confirm Password',
        description: 'Please enter your details',
        email: 'Email',
        emailFieldText:
          'If the email account is valid, you will receive a verification code to continue the password reset process.',
        emailPlaceholder: 'example@email.com',
        errors: {
          confirmPasswordDontMatch: 'Passwords don’t match',
          confirmPasswordIsRequired: 'Confirm password is required',
          emailFormat: 'Invalid email',
          emailIsRequired: 'Email is required',
          verificationCodeIsRequired: 'Code is required',
          verificationCodeMinimumLength: 'The code must be 6 digits at least',
        },
        loadingText: '',
        newPassword: 'Enter New Password',
        passwordChangedSuccessfully: 'Password changed successfully',
        passwordPlaceholder: 'Your password here',
        sendEmailAgain: 'Didn’t receive the code? Send again',
        submit: 'Send',
        titel: 'Reset your password',
        verificationCode: 'Verification Code',
        verificationCodePlaceholder: '6 digits',
      },
      loginForm: {
        description: 'Please enter your details',
        errors: {
          passwordIsRequired: 'Password is required',
          usernameIsRequired: 'Email is required',
        },
        forgotPassword: 'Forgot password',
        loadingText: 'Signing you in ...',
        password: 'Password',
        submit: 'Sign in',
        titel: 'Welcome!',
        username: 'Email',
      },
      passwordRequirements:
        '<div> <div>8 characters minimum length</div> <div>Contains at least 1 number</div> <div>Contains at least 1 uppercase letter</div> <div>Contains at least 1 lowercase letter</div> <div>Contains at least 1 special character</div> </div>',
      verificationCodeForm: {
        accountVerified: 'Your account has been verified.',
        description: 'Enter Verification Code',
        errors: {
          verificationCodeIsRequired: 'Verification code is required',
          verificationCodeMinimumLength: 'The code must be 6 digits at least',
        },
        loadingText: 'Signing you in ...',
        submit: 'Sign in',
        titel: 'Welcome!',
        verificationCode: 'Verification code',
        verificationCodePlaceholder: 'Enter verification code',
      },
    },
    pageHeader: {
      edit: 'Edit',
      groupedActiveFiltersSummary: 'Filters: {{count}}',
    },
    regionsListPage: {
      welcomeMessage:
        'This platform allows you to create and manage regions for the <strong>Hello Britannica English Learning</strong> Platform. Go ahead and create your first region!',
      welcomeTitle: 'Welcome Administrator!',
    },
    schoolDetailsPage: {
      classes: {
        actions: {
          addStudent: 'Add Student',
          delete: 'Delete',
          downloadReport: 'Download Class Report',
          edit: 'Edit',
          viewClass: 'View Class',
        },
        backToClasses: 'Back to Classes',
        classDeletedSuccessfully: 'The class has been successfully deleted.',
        className: 'Class Name',
        classNotFound: 'Class not found',
        continueToUploadingStudents: 'Continue to upload students',
        copyClassCode: 'Code copied successfully',
        create: 'Create',
        deleteClassModal: {
          confirmButton: 'Delete',
          description:
            'Deleting this class will also delete <strong>{{count}}</strong> active students in the class, including their progress and history. Once confirmed, this action cannot be undone.',
          descriptionEmpty: 'You’re about to delete your class. This cannot be undone.',
          descriptionSingular:
            'Deleting this class will also delete <strong>1</strong> active student in the class, including their progress and history. Once confirmed, this action cannot be undone.',
          title: 'Are you sure?',
        },
        deleteTeacherModal: {
          areYouSure: {
            description:
              'Teacher {{teacherName}} has {{numberOfStudents}} students across {{numberOfClasses}} classes. Do you want to permanently delete all students?',
            title: 'Are you sure?',
          },
          cancel: 'Cancel',
          classesWithoutStudents: {
            line: 'Class name - <strong>{{name}}</strong>.',
            lineWithClassCode:
              'Class <strong>{{name}}</strong> /<strong>{{classCode}}</strong> will be deleted.',
            title: 'The following classes will be deleted as well:',
          },
          continue: 'Continue',
          done: {
            btn: 'Done',
            deleted0StudentsXClasses: 'Deleted {{deletedClasses}} empty classes.',
            deletedNStudentsXClasses:
              'Deleted {{deletedStudents}} students and {{deletedClasses}} classes.',
            reassignedTo1Teacher:
              '{{numberOfClasses}} Classes and all associated students have been reassigned to Teacher {{teacherName}}.',
            reassignedToNTeachers:
              '{{numberOfClasses}} Classes and all associated students have been reassigned to other teachers.',
            teacherHasBeenRemoved: '{{teacherName}} is deleted.',
            title: 'Done!',
          },
          ok: 'Ok',
          payAttention: {
            description:
              'You’re about to delete <strong>{{teacherName}}</strong> and all associated data (classes, students, student progress, and class codes). This action cannot be undone.',
            title: 'Pay attention!',
          },
          selectAction: {
            delete: 'Delete',
            description:
              'You can delete the class or assign the class to another teacher. Complete enrollment changes for individual students separately before deleting the teacher.',
            forAllClasses: 'Same teacher for all classes',
            keepRemainingTeacher: 'Keep "{{name}}"',
            moveAllTo: 'Move all classes to:',
            title: 'Please Select an Action',
            to: 'Class "{{name}}" to',
          },
        },
        editClass: 'Edit Class',
        errorLoading: 'Error loading classes: {{error}}',
        failedToFetch: 'Failed to fetch classes',
        filters: {
          classCode: 'Class Code',
          classCodePlaceholder: 'Search class code',
          classSearchPlaceholder: 'Search class',
          gradeSearchPlaceholder: 'Search grade',
          teacherSearchPlaceholder: 'Search teacher',
        },
        gradeLabel: 'Grade',
        gradeOption1st: '1st',
        gradeOption2nd: '2nd',
        gradeOption3rd: '3rd',
        levelControl: {
          allowIndividualAdvancementLabel: 'Automatic Level Progression',
          allowIndividualAdvancementTooltip:
            'Disabling will stop students in this class who complete a level from automatically continuing to the next level.',
          cancelButton: 'Cancel',
          confirmButton: 'Confirm',
          confirmButtonChangeLevel: 'Change Level',
          confirmButtonDisableLevelProgression: 'Disable Level Progression',
          confirmButtonDisableLevelTest: 'Disable Level Test',
          confirmButtonEnableLevelProgression: 'Enable Level Progression',
          confirmButtonEnableLevelTest: 'Enable Level Test',
          confirmButtonSetLevel: 'Set Level',
          confirmTitle: 'Are you sure?',
          defaultStartingLevelLabel: 'Initial Level',
          defaultStartingLevelPlaceholder: 'Initial Level',
          defaultStartingLevelRequired: 'Please select a default starting level.',
          placementTestRequiredLabel: 'Level Test',
          placementTestRequiredTooltip:
            'Disabling will skip the level placement test for students in this class. You will be required to assign their starting level.',
          warnings: {
            advancementTurnedOff:
              'Turning off automatic level progression means students will stay at their completed level when they finish it. They can repeat activities for more practice.',
            advancementTurnedOn:
              'Turning on automatic level progression means students in this class who have already completed their level will automatically move ahead to the next level on their next login. Any students in this class who complete their level in the future will also move ahead immediately.',
            advancementTurnedOnExistingClass:
              'Turning on automatic level progression means any students who already completed their level will move ahead on their next login. Students who complete their level in the future will also move ahead automatically.',
            advancementTurnedOnNewClass:
              'Turning on automatic level progression means students will move ahead to the next level automatically when they complete their current one.',
            defaultLevelChanged:
              'Changing the class default level will assign the new default to any existing students who have not yet engaged in activities and those who join or are invited to this class in the future. Students in this class who are already engaged will not be affected, and their level might be different than the default. If necessary, you may change existing students’ current level individually or in bulk.',
            defaultLevelChangedExistingClass:
              'This default level will apply to any students who haven’t engaged in activities yet and to any who join this class in the future. Engaged students will not be affected.',
            defaultLevelChangedNewClass:
              'This default level will apply to all students in the class.',
            placementTestTurnedOff:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Students in this class who are already active will not be affected, and their level might be different than the default.',
            placementTestTurnedOffExistingClass:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Engaged students will not be affected.',
            placementTestTurnedOffNewClass:
              'Turning off the level test means all students will be assigned the class default level.',
            placementTestTurnedOn:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Students in this class who are already active will not be affected.',
            placementTestTurnedOnExistingClass:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Engaged students will not be affected.',
            placementTestTurnedOnNewClass:
              'Turning on the level test means all students will need to complete it before starting to engage in activities.',
          },
        },
        newClass: 'Add Class',
        placeholderWriteHere: 'Write here',
        saveClassAndAddLater: 'Save and add students later',
        searchPlaceholder: 'Search classes',
        teachersLabel: 'Teachers (Up to 2)',
        teachersPlaceholder: 'Choose',
        teachersSearchPlaceholder: 'Search teacher',
        title: 'Classes',
        viewClassPage: {
          addStudents: 'Add Students',
          classCodeLabel: 'Class Code',
          coTeacher: 'Co-Teacher (Optional)',
          editClass: 'Edit class',
          metaActiveLabel: 'Active',
          metaInactiveLabel: 'Inactive',
          metaStudentsLabel: 'Students',
          studentColumnName: 'Name & Status',
          teacher: 'Teacher',
        },
        viewClasses: 'View Classes',
        zeroState: {
          buttonText: 'Add Class',
          description:
            'Create a class, add students, and let them begin their English learning journey.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'Create your first class!',
        },
      },
      editSchool: 'Edit',
      general: {
        country: 'Country',
        expirationDate: 'Expiration Date',
        licensesUsage: 'Licenses Used',
        sharedLicenseHint:
          '*The total number of licenses is shared across multiple schools under the same agreement. The number of licenses available may change based on usage by other schools.',
        title: 'School Snapshot',
        totalClasses: 'Total Number of Classes',
        totalStudents: 'Total Number of Students',
        totalTeachers: 'Total Number of Teachers',
      },
      loadingSchoolDetails: 'Loading school details...',
      newClassForm: {
        classNamePlaceholder: 'Write here',
      },
      notFound: 'School not found.',
      students: {
        allLevels: 'All levels',
        allLevelsHint: 'Data reflects the student’s work in all levels.',
        changeLevel_one: 'Change Level',
        changeLevel_other: 'Change Level',
        currentLevel: 'Сurrent level',
        deleteStudents_one: 'Delete Student',
        deleteStudents_other: 'Delete Students',
        displayDataFor: 'Display data for',
        errorLoading: 'Error loading students: {{error}}',
        failedToFetch: 'Failed to fetch students',
        moveStudents_one: 'Move Student',
        moveStudents_other: 'Move Students',
        searchPlaceholder: 'Search students',
        subTitle: '*The starting level was changed.',
        title: 'Students',
        titleOnSelected_one: '1 of {{maxNum}} records selected',
        titleOnSelected_other: '{{num}} of {{maxNum}} records selected',
        zeroState: {
          description:
            'Once you add students, you’ll be able to manage them here and view all their information in one place.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'No students enrolled in the class yet!',
        },
      },
      teachers: {
        addManually: 'Upload File / Add Manually',
        copyLink: 'Copy Link',
        errorLoading: 'Error loading teachers: {{error}}',
        failedToCreate: 'Failed to create teacher',
        failedToFetch: 'Failed to fetch teachers',
        filters: {
          teachers: 'Teacher Name',
          teachersSearchPlaceholder: 'First and last name',
        },
        inviteLinkDescription: 'Copy and share the link below to invite your teachers to log in.',
        inviteYourTeachers: 'Invite Your Teachers',
        linkCopied: 'Link Copied!',
        linkCopiedMessage: 'Now you can share the link with your teachers.',
        newTeacher: 'Add Teacher',
        searchPlaceholder: 'Search teachers',
        title: 'Teachers',
        zeroState: {
          description: 'Add your teachers, so they can create classes and add students.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'Enroll your teachers!',
        },
      },
    },
    schoolsListPage: {
      allLevelsHint: 'Data reflects the student’s work in all levels.',
      classCreated: 'The class has been created successfully!',
      columns: {
        activeUsers: 'Active Users',
        registeredUsers: 'Registered Users',
        schoolAdmin: 'School Admin',
        schoolAdminEmail: 'School Admin Email',
        schoolName: 'School Name & Type',
        status: 'Status',
      },
      createNewSchool: '+ Create New School',
      filters: {
        adminEmail: 'Admin Email',
        schoolAdmin: 'School Admin',
        schoolType: 'School Type',
      },
      newSchool: 'New School',
      studentCreatedSuccessfully: 'Student created successfully!',
      studentsCreatedInClass: 'Students created successfully in class {{className}}!',
      title: 'Schools',
    },
    schoolsTable: {
      addNew: '+ Add New School',
      columns: {
        contact: 'Contact',
        school: 'School',
        students: 'Students',
        teachers: 'Number of Teachers',
      },
      noResults: 'There are no Schools created in this deal.',
    },
    settings: {
      about: 'About',
      about_me: {
        my_account: 'My School',
        my_language: 'My Home Language',
        my_name: 'My Name',
        title: 'About Me',
      },
      account_settings: 'Account settings',
      add_students: {
        add_student: 'Add Student',
        classCreatedDescription:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will receive a Level Test. Based on the results, they will be placed at their appropriate level and may begin their learning journey.',
        classCreatedDescriptionNoLevelTest:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
        create_students: 'The following students will receive an invitation email:',
        enroll_students: 'Add students',
        enrollment_unsuccessful_description_validation:
          'The following students could not enroll due to validation errors:',
        errors: {
          file_empty: 'The file you are trying to upload is empty.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          wrong_format:
            'The file format is incorrect. Please ensure you are uploading an Excel (xlsx) file.',
        },
        partial_success_description:
          '{{addedStudents}} of {{totalStudents}} students have successfully enrolled in this class.<br/>They have been sent an email with their temporary password.',
        student_creation_error: ' Students not added. Please try again.',
        studentsSuccessfullyEnrolled: 'The students have been successfully enrolled.',
        upload_file: 'Upload your students Excel file.',
      },
      add_teachers: {
        add_teacher: 'Add Teacher',
        add_teachers_manually: 'Add Manually',
        button_next: 'Next',
        click_to_browse: 'click to browse',
        create_teacher: 'Create Teacher',
        create_teachers: 'The following teachers will receive an invitation email:',
        download: 'Download',
        download_sample: 'a sample Excel (xlsx) file',
        drag_here: 'Drag a file here or ',
        enroll_teachers: 'Add teachers',
        enrollment_unsuccessful: '⚠️ Teacher Addition Unsuccessful!',
        enrollment_unsuccessful_description:
          'The following teachers could not be added because their email has already been used:',
        enrollment_unsuccessful_description_validation:
          'The following teachers could not be added due to validation errors:',
        errors: {
          bad_formatting:
            'Your file is not formatted correctly. <br/> Please check your data and make corrections as needed',
          email_in_use: 'This email address is already registered',
          email_incorrect: 'Please enter a valid email address.',
          file_empty: 'The file you are trying to upload is empty.',
          file_too_large: 'The file is too large. Maximum size allowed is 256KB.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          first_name_missing: 'First name is required.',
          first_name_too_long: 'First name can be up to 30 characters.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          last_name_missing: 'Last name is required.',
          last_name_too_long: 'Last name can be up to 40 characters.',
          limit_reached:
            'The maximum number of teachers is 50. <br/> Please remove and upload a new file.',
          limit_reached_description: 'Your class contains the maximum number of teachers allowed.',
          limit_reached_title: 'This class is already full.',
          max_number_of_teachers:
            'The maximum number of teachers is 50. <br/> Please remove and upload a new file.',
          teachers_not_registered: 'Some teachers were not registered',
          username_invalid: 'This username is already taken',
          username_missing: 'Username is required.',
          wrong_format:
            'The file format is incorrect. Please ensure you are uploading an Excel (xlsx) file.',
        },
        invite_teachers: 'Invite Teachers',
        not_enough_licenses:
          'Not enough licenses available to complete this operation. {{available}} licenses available, but {{requested}} teachers were requested.',
        partial_success: '⚠️ Partial Success',
        partial_success_description:
          '{{addedTeachers}} out of {{totalTeachers}} teachers have successfully added.<br/>They have been sent an email with their temporary password.',
        register_your_teachers: 'Register Your Teachers',
        success_description:
          'Your teachers have been sent an email with instructions on resetting their password.<br/>Once they are done, they will be able to begin using Hello Britanica.',
        teacherCreationError: 'Teachers not added. Please try again.',
        teacher_creation_error: 'Teachers not added. Please try again.',
        teachers_added: 'The teachers have been added successfully!',
        upload_attention_text:
          '⚠️ Your organization contains {{curent}}/{{limit}} teachers.<br/>You may add {{certified}} more teachers.',
        upload_attention_text_new_class: '⚠️ Max. {{limit}} teachers',
        upload_file: 'Upload your teachers Excel file.',
        upload_successful: 'Your file has been uploaded successfully.',
      },
      delete_class: {
        classNotEmpty: 'You can’t delete a class that contains students.',
        classNotEmptyDescription:
          'If you would like to delete this class, you must first delete those students. You can do this by opening the student’s profile and clicking the Edit icon.',
      },
      delete_student: {
        tryAgain: 'Try again',
      },
      language_of_study: 'Language of study',
      native_language: 'My Home Language',
      passwordRequirements: {
        atLeastOneLowercase: 'Contains at least 1 lowercase letter',
        atLeastOneNumber: 'Contains at least 1 number',
        atLeastOneSpecial: 'Contains at least 1 special character',
        atLeastOneUppercase: 'Contains at least 1 uppercase letter',
        passwordMinimumLength: '8 characters minimum length',
      },
      preferences: 'Preferences',
      school_id: 'My School',
      suggested_languages: 'Suggested Languages',
    },
    statesListPage: {
      welcomeMessage:
        'This platform allows you to create and manage states for the <strong>Hello Britannica English Learning</strong> Platform. Go ahead and create your first state!',
      welcomeTitle: 'Welcome Administrator!',
    },
    statsCardGroup: {
      averageSessionTime: '📊 Average Time Spent',
      averageSessionTimeEmpty: 'Students haven’t begun activities yet',
      averageSessionTimeTooltip: 'Average time spent by students actively completing activities',
      engagedStudents: '🟢 Engaged Students',
      engagedStudentsEmpty: 'Students haven’t completed any activities yet',
      engagedStudentsTooltip: 'Students who have begun at least one activity',
      engagedTeachers: '🟢 Engaged Teachers',
      engagedTeachersEmpty: 'Teachers did not create classes yet',
      engagedTeachersTooltip: 'Teachers who own at least one class',
      passiveStudents: '🟢 Passive Students',
      passiveStudentsEmpty: 'No students enrolled in the class yet',
      passiveStudentsTooltip: 'Students who haven’t begun any activities',
      totalTimeSpent: 'Total Time Spent',
      totalTimeSpentEmpty: 'Students haven’t begun activities yet',
      totalTimeSpentTooltip: 'Total time spent by students actively completing activities',
    },
    studentDataModal: {
      activities: 'Activities',
      completedLevelNotice:
        "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
      days: {
        friday: 'Fri',
        monday: 'Mon',
        saturday: 'Sat',
        sunday: 'Sun',
        thursday: 'Thurs',
        tuesday: 'Tues',
        wednesday: 'Wed',
      },
      deleteStudentForm: {
        areYouSure: 'Are you sure?',
        cancel: 'Cancel',
        choose: 'Choose',
        close: 'Close',
        delete: 'Delete',
        deletingFailed: 'Deleting failed.',
        deletingFailedDescription:
          'Our servers are not responding. Please try again. If the problem persists, please contact us at <a href="mailto:{{email}}">{{email}}</a>',
        description:
          'Deleting this student will permanently remove them from the platform. This student will no longer be able to log in and all progress data will be lost. Please provide a reason:',
        oops: 'Oops!',
        reason: 'Reason',
        reasons: {
          aClericalError: 'A clerical error',
          other: 'Other',
          requestedToBeRemoved: 'The student or parent requested to be removed',
        },
        tryAgain: 'Try again',
        why: 'Why?',
      },
      editForm: {
        ChooseAnotherLevel: 'Choose another level',
        areYouSure: 'Are you sure?',
        cancel: 'Cancel',
        changingLevel: 'Changing the student’s level will delete their progress and history!',
        currentLevel: 'Current level',
        deleteStudent: 'Delete student',
        edit: 'Edit',
        email: 'Email',
        errors: {
          anErrorOccurred: 'An error has occurred',
          email_incorrect: 'Please enter a valid email address.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          first_name_missing: 'First name is required.',
          first_name_too_long: 'First name can be up to 30 characters.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          last_name_missing: 'Last name is required.',
          last_name_too_long: 'Last name can be up to 40 characters.',
        },
        firstname: 'First Name',
        interfaceLanguage: 'Interface language',
        language: 'Language',
        lastname: 'Last Name',
        level: 'Level',
        save: 'Save',
        userDataSuccessfullyUpdated:
          'The details have been successfully updated. Please ask student to refresh the page to see the change.',
        username: 'Username',
        yes: 'Yes',
      },
      firstLogin: 'First login',
      interfaceLanguage: 'Interface language',
      level: 'Level',
      progress: 'Progress',
      report: {
        activitiesCompletedInLevel: 'Activities Completed in Level {{level}}',
        allLevelsAvgTime: "📊 All level's avg. time",
        attemptsAndHints: 'Attempts & Hints',
        avgAttemptsPerActivity: 'Average per activity',
        avgHintsPerActivity: 'Avg. hints per activity',
        avgPerWeek: 'Avg. per week',
        avgProgress: 'Average Progress',
        avgSkillScores: 'Skill Scores',
        avgStreakPerWeek: 'Avg. streak per week',
        classDataNotAvailable: 'The data for this class is not available.',
        continuousEngagement: 'Continuous Engagement',
        date: 'Date',
        engagement: 'Engagement',
        failureRate: 'Fail Rate',
        generateReport: 'Generate Report',
        inCurrentLevel: 'In Current Level',
        level: 'Level',
        longestStreak: 'Longest streak',
        overallProgressInLevel: 'Overall Progress in Level {{level}}',
        passRate: 'Pass Rate',
        previous7Days: 'Previous 7 days',
        progress: 'Progress',
        skippedActivitiesComment: '* Skipped activities are included in total activities',
        streakLast7Days: 'Streak over last 7 days',
        streakLength: 'Streak Length',
        studentName: 'Student Name',
        studentReport: 'Student Report',
        timeSpentOnActivites: 'Time Spent on Activites',
        total: 'Total',
        totalHintsUsed: 'Total hints used',
        totalInPrev7Days: 'Total in prev. 7 days',
        tryAgainLater: 'Try again later!',
        weCouldNotProduce: 'The report cannot be generated at the moment.',
        weStillDontHaveAll: "We still don't have all the necessary information.",
      },
      schoolName: 'School Name',
      selfPracticeStreak: 'Self Practice Streak',
      thisStudentIsInactive:
        'This student is inactive. They have been invited to the class, but have not yet started the initial level placement test.',
      thisStudentIsLevelTestIncomplete:
        'This student has not yet completed the initial level placement test. Once they have done so, you’ll be able to see their progress.',
      topics: 'Topics',
      totalProgressWithinLevel: 'Total Progress within the level',
      unitData: {
        activities: 'Activities',
        canDo: 'Can Do',
        completed: 'Completed',
        failed: 'Failed',
        level: 'Level',
        skipped: 'Skipped',
        somethingWentWrong: 'Something went wrong. Please, try again later',
        stars: 'Stars',
        toggle: 'Toggle',
        topics: 'Topics',
        totalActivities: 'Total Activities',
      },
      viewPerformance: 'View Performance',
    },
    studentMetricsDashboard: {
      charts: {
        avgStudentGrowth: {
          averageGrowth: 'Average Growth',
          month: 'Month',
        },
        kpis: {
          averageTimeSpent: {
            tooltip: 'Average time spent by students actively completing activities',
          },
          passRate: {
            tooltip: 'The percentage of activities that were successfully passed.',
          },
          totalTimeSpent: {
            tooltip: 'Total time spent by students actively playing',
          },
        },
        studentsAcrossSkills: {
          tooltipStudents: 'students',
        },
      },
      drillDown: {
        students: {
          columns: {
            classNameAndGrade: 'Class & Grade',
            coTeacherName: 'Co-Teacher Name',
            nameAndCoTeacher: 'Name & Co-Teacher',
            nameAndTeacher: 'Name & Teacher',
          },
        },
      },
      emptyState: {
        filter: {
          description: 'Try adjusting or resetting the filters to view data.',
          title: 'No data available for the selected filters.',
        },
        noStudents: {
          description:
            'Once you add students, you’ll be able to manage them here and view all their information in one place.',
          title: 'No students added yet!',
        },
      },
      filters: {
        coTeacher: 'Co-Teacher Name',
        fail: 'Fail',
        pass: 'Pass',
        score: 'Score',
        status: 'Status',
        statusSearchPlaceholder: 'Search status',
      },
      totalStudents: 'Engaged Students: {{totalStudents}} ',
    },
    tabbedCard: {
      addNew: '+ Add New',
      tabs: {
        districts: 'Districts',
        schools: 'Schools',
      },
    },
    topic: 'Topic',
    university: 'university',
    validation: {
      mustBeAtLeastCharacters: 'This field must be at least {{length}} characters',
    },
  },
  adminInstructions: 'Admin Instructions',
  again: 'שוב',
  all: 'הכול',
  allDone: 'הכול מוכן!',
  allLevels: 'כל הרמות',
  almostFinish: 'כמעט סיימת!',
  almostMadeIt: 'כמעט סיימת',
  almostThere: 'עוד קצת וסיימת...',
  amazing_job: 'כל הכבוד!',
  anErrorOccurred: 'אירעה שגיאה',
  andInviteYourStudents: 'ולהזמין את התלמידים שלך',
  andThenInvite: 'ואחר כך להזמין את התלמידים שלך להצטרף אליה',
  answerNotAccepted: 'התשובה לא התקבלה',
  answeredIncorrectly: ', ענית עליהן לא נכון.',
  appName: 'Hello Britannica',
  appTitle: 'Britannica',
  areYouReadyForTheQuiz: 'רוצה להתחיל את החידון?',
  areYouSure: 'האם אתם בטוחים?',
  asSoonAsTheyStart: 'אחרי שהסיסמה הזמנית תוחלף, הסטטוס ישתנה לפעיל',
  asSoonAsTheyStartGoogle:
    'הכיתה שלך נוצרה, ועכשיו צריך להוסיף את התלמידים שלך! <br/> נא להשתמש בלחצן הסנכרון כדי להעביר את התלמידים שלך מהכיתה שלך ב-Google Classroom לפלטפורמת Hello.',
  assessment: 'מבדק סיום',
  assessments: 'הערכות',
  atLeastOneLowercase: 'הסיסמה צריכה להכיל אות קטנה אחת לפחות',
  atLeastOneNumber: 'הסיסמה צריכה להכיל מספר אחד לפחות',
  atLeastOneSpecial: 'הסיסמה צריכה להכיל לפחות תו אחד מיוחד',
  atLeastOneUppercase: 'הסיסמה צריכה להכיל אות גדולה אחת לפחות',
  avgAttempts: 'מספר ניסיונות ממוצע',
  avgCurrentLevel: 'רמה נוכחית ממוצעת',
  avgCurrentLevelTooltip: 'הרמה הנוכחית הממוצעת של תלמידים.',
  avgCurrentLevel_mobile: 'רמה נוכחית ממוצעת',
  avgFailureRate: '❌אחוז כישלון ממוצע',
  avgLevel_mobile: 'רמה ממוצעת',
  avgPassRate: '✅ אחוז הצלחה ממוצע',
  avgProgress: 'התקדמות ממוצעת',
  avgProgressTooltip: 'ההתקדמות הממוצעת של התלמידים ברמתם הנוכחית.',
  avgProgress_mobile: 'התקדמות ממוצעת',
  avgScore: 'ציון ממוצע',
  avgScoreTooltip: 'הציון הממוצע של התלמידים בפעילויות השונות ברמה הנוכחית שלהם.',
  avgScore_mobile: 'ציון ממוצע',
  avgTimeSpent: 'זמן ביצוע ממוצע',
  avgTimeSpentTooltip: 'הזמן הממוצע שהתלמידים שיחקו במהלכו באופן פעיל.',
  avgTimeSpent_mobile: 'זמן ביצוע ממוצע',
  back: 'חזרה',
  backHome: 'חזרה לדף הבית',
  backOnline: 'נראה שחזרת למצב מקוון!',
  backOnlineActivities: 'עכשיו אפשר לחזור לפעילויות שדילגנו עליהן.',
  bimloaFilter: {
    all: 'הכול',
    close: 'סגירה',
    filter: 'סינון',
    filterBy: 'סינון',
    max: 'מקסימום',
    min: 'מינימום',
    reset: 'איפוס',
    resetAll: 'איפוס הכול',
    to: 'אל',
  },
  britannicaEducationWith: 'לשאלות והערות.',
  byClickingOn:
    'אם בוחרים שם מרשימת התלמידים, אפשר לראות את ההתקדמות של כל אחת ואחד בכל תחום לימוד ואת התדירות של השימוש בתוכנה. אפשר גם לבחור את שפת הממשק שלהם.',
  cameraPermission: {
    button: 'יש לנסות שוב',
    text: 'הרשאת הגישה למצלמה נדחתה. נא לאפשר גישה למצלמה בהגדרות הדפדפן שלך.',
  },
  canDo: 'Can Do',
  cancel: 'ביטול',
  change_password: 'החלפת סיסמה',
  changingLevel: 'שינוי הרמה ימחק את ההתקדמות וההיסטוריה של התלמיד או התלמידה!',
  characters: 'תווים',
  checkInSpamMessage: 'לא קיבלת את המייל? כדאי לבדוק בתיקיית <0> הספאם</0>  שלך.',
  choose: 'בחירה',
  chooseAvatar: 'בחירת אווטר',
  chooseGrade: 'בחירת שכבה',
  chooseTheCorrectAnswer: 'בחרו בתשובה המתאימה ביותר למילוי המשפט:',
  chooseUsername: 'בחירת שם משתמש',
  chooseYourClasses: 'נא לבחור את הכיתות שברצונך להוסיף מ-Google Classroom',
  chooseYourFavoriteAvatar: 'נא לבחור אווטר וצבע',
  city: 'יישוב',
  class: 'כיתה',
  classCode: 'קוד כיתה',
  classCodeClassLimitReached: 'הכיתה הזאת הגיעה לגבול מכסת התלמידים שלה',
  classCodeDealInvalidCode:
    'הקוד אינו תקין. נא לבדוק את מה שכתבת או ליצור קשר עם המורה שלך לקבלת קוד כיתה חדש.',
  classCodeDealLimitReached: 'בית הספר שלך הגיע לגבול מכסת המינויים שלו.',
  classCodeDealNotActive: 'פג תוקפו של הקישור שאתה מנסה להגיע אליו',
  classCodeDealNotValid:
    'פג תוקפו של קוד הכיתה שכתבת. נא לבדוק את מה שכתבת או ליצור קשר עם המורה שלך לקבלת קוד כיתה חדש.',
  classCodeNotActive:
    'קוד הכיתה אינו פעיל. נא לבדוק את מה שכתבת או ליצור קשר עם המורה שלך לקבלת קוד כיתה חדש.',
  classCreated: 'הכיתה נוצרה בהצלחה!',
  className: 'שם הכיתה',
  classReport: 'דו"ח כיתתי',
  classWasDeleted: 'נראה שהכיתה "{{className}}" נמחקה מ-Google Classroom',
  classWasDeletedDescription: 'לא ניתן לבצע פעולה זו עד להסרת הכיתה שנמחקה.',
  classes: 'כיתות',
  classesDeleted: 'הכיתה נמחקה בהצלחה!',
  classesDeletedDescription: 'לא תהיה לך יותר אפשרות לראות את הכיתה הזאת או לערוך אותה',
  classesImported: 'הכיתות שלך יובאו!',
  clickHere: 'לחצו כאן!',
  close: 'סגירה',
  closeMenu: 'סגירת תפריט',
  coTeacher: 'עוד מורה',
  cognitoErrors: {
    CodeMismatchException: 'קוד האימות אינו תקין, נא לנסות שוב.',
    ExpiredCodeException: 'קוד האימות אינו תקין, נא לבקש שוב קוד.',
    LimitExceededException: 'נגמר מספר הניסיונות האפשריים, נא לנסות שוב לאחר זמן מה.',
    NetworkError: 'Network error. Please check your internet connection and try again.',
    NewPasswordRequiredSessionExpired: "נגמר הזמן לבחירת הסיסמה. נא ללחוץ על 'חזרה' ולנסות שוב.",
    NotAuthorizedException: 'דוא"ל או סיסמה שגויים',
    UserNotConfirmedException: 'החשבון שלך לא מאומת. נא להזין את קוד האימות שנשלח למייל שלך.',
    UsernameExistsException: 'שם המשתמש הזה כבר תפוס',
  },
  coins: 'מטבעות',
  coinsInstructions: 'אפשר להשתמש בהם כדי לקבל עזרה במהלך החידונים.',
  coinsWillBeLost: 'והמטבעות שצברת לא יישמרו.',
  comingSoon: 'בקרוב<br/>',
  complete: 'סיימת',
  completeImportError: 'לא הייתה אפשרות לייבא את הכיתות שלך, מכיוון שהן כבר יובאו בידי מורה אחר/ת.',
  completed: 'הושלם',
  completedActivities: 'סך כל הפעילויות שהושלמו ברמה זו',
  completedLevelNotice:
    "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
  confirmPassword: 'אישור הסיסמה',
  contactAdmin: 'נא לפנות להנהלת בית הספר שלך לקבלת הדרכה.',
  contactOurTeam: 'צרו איתנו קשר',
  contactOurTeamWithQuestions: 'צרו קשר עם הצוות שלנו לשאלות והערות.',
  contactTeacher: 'יש ליצור קשר עם המורה שלך כדי לקבל סיסמה זמנית!',
  contactUs: 'כתבו לנו',
  contactUsSubtitle: 'Our team will provide you answers and guidance.',
  continue: 'המשך',
  continueOnWeb: 'המשך באתר',
  continueQuiz: 'המשך',
  continueToQuestions: 'המשך לשאלות',
  continue_level_test: 'המשך מבחן הרמה',
  copy: 'העתקה',
  copyInvitationLink: 'העתקת קישור להזמנה',
  copyLink: 'העתקת קישור',
  copyTemporaryPassword: 'העתקת הסיסמה',
  copyTemporaryPasswordDescription:
    'ניתן להעתיק את הסיסמה ולשלוח אותה אל {{firstName}} {{lastname}}!',
  copyright: 'אנציקלופדיה בריטניקה בע"מ, 2025.',
  couldNotLocate: 'לא הצלחנו לאתר את הדף שחיפשת.',
  country: 'מדינה',
  create: 'יצירה',
  createClass: 'יצירת כיתה',
  createClassCode: 'יצירת קוד כיתה',
  createNewClass: 'יצירת כיתה',
  createYourClass: 'נא ליצור כיתה ולהזמין אליה את התלמידים שלך',
  createYourFirstClass: 'כאן אפשר ליצור את הכיתה הראשונה שלך',
  createYourFirstClassDescription:
    'יש להגדיר כיתה, ואחר כך להעלות רשימה של תלמידים שברצונך לרשום לכיתה זו. לאחר מכן אפשר להזמין את התלמידים שלך להצטרף.',
  currentLevel: 'רמה נוכחית',
  current_password: 'הסיסמה הנוכחית',
  customYourLearning: 'בקרוב נוכל להתאים לך מסלול למידה אישי!',
  dashboard: 'התקדמות',
  date: 'תאריך',
  dealLimitReachedMessageAdminDescription:
    'No additional students can be added. Please contact us for assistance.',
  dealLimitReachedMessageAdminTitle: 'Your school’s license limit has been reached.',
  dealLimitReachedMessageDescription: 'נא לפנות להנהלת בית הספר שלך לקבלת הדרכה.',
  dealLimitReachedMessageTitle: 'בית הספר שלך הגיע לגבול מכסת המשתמשים שלו.',
  dearSchoolAdmin: 'שלום רב,',
  dearTeacher: 'שלום למורה, קיבלת הזמנה להצטרף לבית הספר',
  delete: 'מחיקה',
  deleteClass: 'מחיקת כיתה',
  deleteClasses: 'מחיקת כיתות',
  deleteClassesAttention:
    'לתשומת ליבך, במקרה של מחיקת כיתה, כל הנתונים שלה יוסרו ולא יתאפשר לשחזר אותם. כל התקדמות התלמידים תימחק.',
  deleteClassesDescription:
    'לתשומת ליבך, במקרה של מחיקת כיתה, כל הנתונים שלה יוסרו ולא יתאפשר לשחזר אותם. כל התקדמות התלמידים תימחק.',
  dictionary: 'מילון',
  didntQuiteHearThat: 'מה שאמרת לא נקלט במערכת.',
  doYouHaveAClassCode: 'יש לך קוד כיתה? ',
  doingGreat: 'התקדמת יפה!',
  done: 'בוצע',
  dontKnow: 'לא ידוע לי',
  downloadAndView: 'הורדה וצפייה של',
  downloadClassReport: 'הורדת דו"ח כיתה',
  downloadList: 'רשימת הורדות',
  edit: 'עריכה',
  editClass: 'עריכת כיתה',
  editClassClassNameAlreadyExists: 'כבר יש כיתה עם השם הזה',
  editClassInvalidClassName: 'נא להזין את שם הכיתה',
  editClassInvalidClassNameFormat: 'Class name contains invalid characters.',
  editClassInvalidGrade: 'נא לבחור שכבה',
  editClassInviteNewStudent: 'הוספת תלמידים',
  editClassStudentFullClassDescription: 'הכיתה שלך מכילה את <br/> מספר התלמידים המרבי המותר.',
  editClassStudentFullClassTitle: 'הכיתה הזאת כבר מלאה.',
  editClassStudentNewStudentAddedDescription:
    'הם קיבלו אימייל עם הוראות לאיפוס הסיסמה. לאחר שהם  יתחברו למערכת, הם יעברו מבחן רמה לשיבוץ ברמה המתאימה כדי להתחיל את המסע ללימוד אנגלית.',
  editClassStudentNewStudentAddedTitle: 'נשלחה הזמנה!',
  editClassStudentStatus: 'סטטוס',
  editClassStudentStatusActive: 'במצב פעיל',
  editClassStudentStatusInactive: 'במצב לא פעיל',
  email: 'כתובת מייל',
  emailExample: 'example@gmail.com',
  emailOrUsername: 'כתובת דוא"ל או שם משתמש',
  emailVerification: 'אימות דואר אלקטרוני',
  englishLearningJourney: 'ללמוד אנגלית עם  Hello Britannica.',
  englishLearningJourneyMorfix: 'ללמד אנגלית עם Hello Britannica',
  englishSkillsAssessments: 'הערכות מיומנויות באנגלית',
  enterCodeHere: 'נא להזין את הקוד',
  enterNewPassword: '‏‎סיסמה חדשה‎‏',
  enterVerificationCode: 'נא להזין קוד אימות',
  enterVerificationCodeAndNewPassword: 'יש להזין את קוד האימות ואת הסיסמה חדשה',
  enterVerificationCodeHelpText: 'נא להזין את הקוד שקיבלת מהנהלת בית הספר שלך.',
  enterYourAnswerHere: 'נא להזין תשובה כאן',
  error: {
    apiMessages: {
      accessDenied: 'Access denied.',
      accessDeniedOrStudentNotFound: 'Access denied or the student is not found.',
      accessDeniedOwnSchoolOnly: 'Access denied - you can only access data from your own school.',
      atLeastOneNameRequired: 'At least one field (first name or last name) must be provided.',
      atLeastOneTeacherRequired: 'At least one teacher must be assigned to the class.',
      atLeastOneUserRequired: 'At least one user is required.',
      classCodeRequired: 'Class code is required.',
      classCodeValidationFailed: 'Failed to process the class code validation response.',
      classReportNotFound: 'Class report not found.',
      dealNotFound: 'Deal not found.',
      dealNotFoundOrInvalid: 'Deal not found or is invalid.',
      dealValidationFailed: 'Deal validation failed.',
      errorCheckingTeacherDeletionEligibility:
        'An error occurred while checking teacher deletion eligibility. Please, try again later.',
      errorCreatingDeal:
        'An error occurred while creating or updating the deal. Please, try again later.',
      errorCreatingGroup: 'An error occurred while creating the group. Please, try again later.',
      errorCreatingPrincipalAdmin:
        'An error occurred while creating the principal admin. Please, try again later.',
      errorDeletingUser: 'An error occurred while deleting the user. Please, try again later.',
      errorProcessingDeletionRequest:
        'An error occurred while processing the deletion request. Please, try again later.',
      errorProcessingTeacherDeletionActions:
        'An error occurred while processing teacher deletion. Please, try again later.',
      errorSigningOut: 'An error occurred while signing out. Please, try again later.',
      errorValidatingClassCode:
        'An error occurred while validating the class code. Please, try again later.',
      errorValidatingDeal: 'An error occurred while validating the deal. Please, try again later.',
      failedToCreateAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateComprehensiveAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateGroup: 'Failed to create a group. Please, try again later.',
      failedToCreateRegion: 'Failed to create region. Please, try again later.',
      failedToCreateStudent: 'Failed to create student. Please, try again later.',
      failedToDeleteGradeConfiguration:
        'Failed to delete grade configuration. Please, try again later.',
      failedToDeleteTeacher: 'Failed to delete teacher. Please, try again later.',
      failedToDeleteTeacherWithActions:
        'Failed to process teacher deletion. Please, try again later.',
      failedToDeleteUser: 'Failed to delete user. Please, try again later.',
      failedToGenerateAdminGuideUrl:
        'Failed to generate the admin guide URL. Please, try again later.',
      failedToProcessUserCreation:
        'Failed to process the user creation request. Please, try again later.',
      failedToRegisterDevice: 'Failed to register the device. Please, try again later.',
      failedToRetrieveDealList: 'Failed to retrieve the deal list.',
      failedToRetrieveRegions: 'Failed to retrieve regions.',
      failedToRetrieveStudentMetrics: 'Failed to retrieve student metrics.',
      failedToRetrieveStudentSkillPerformance: 'Failed to retrieve student skill performance data.',
      failedToRetrieveUserList: 'Failed to retrieve the user list.',
      failedToRetrieveUserStatistics: 'Failed to retrieve user statistics.',
      failedToSaveGradeConfiguration:
        'Failed to save grade configuration. Please, try again later.',
      failedToSetInterfaceLanguage:
        'Failed to set the interface language. Please, try again later.',
      failedToSetStudentSettings: 'Failed to set student settings. Please, try again later.',
      failedToSetUserAvatar: 'Failed to set the user avatar. Please, try again later.',
      failedToSignOut: 'Failed to sign out. Please, try again later.',
      failedToUpdateActivities: 'Failed to update user activities.',
      failedToUpdateGroup: 'Failed to update group. Please, try again later.',
      failedToUpdateTeacher: 'Failed to update teacher. Please, try again later.',
      forbidden: 'Action forbidden.',
      googleUserNotFound: 'Google user not found.',
      gradeConfigurationNotFound: 'Grade configuration not found.',
      groupDeletionFailed: 'Group deletion failed. Please, try again later.',
      groupNotFound: 'Group not found.',
      groupsNotFound: 'Groups not found.',
      groupsReportNotFound: 'Groups report not found.',
      groupsReportTimedOut:
        'The request timed out while retrieving the groups report. Please, try again later.',
      incompleteResponseData: 'The response was successful, but the data was incomplete.',
      incompleteStudentCreationResponse:
        'The response was successful, but the data was incomplete. Students may have been created – please refresh and verify.',
      internalErrorCreatingToken: 'An internal server error occurred while creating the token.',
      invalidAdminManagementResponse: 'Invalid response from the admin management service.',
      invalidDealName: 'Invalid deal name.',
      invalidInputs: 'One or more inputs are invalid.',
      invalidIntsProvided: 'Please enter valid numbers.',
      invalidLevelProvided: 'Invalid level provided.',
      invalidNotificationsResponse: 'Invalid response from the notifications service.',
      invalidOrgOrDeal: 'Invalid request: missing organization details or deal ID.',
      invalidRequest: 'Invalid request.',
      invalidRequestParameters: 'Invalid request parameters.',
      invalidSchoolDealNames:
        'School name, deal name, and school manager names must not contain numbers, and first/last names must not exceed 40 characters.',
      invitationLinkNotFound: 'Invitation link not found.',
      languagePreferencesNotFound: 'Language preferences not found for this school.',
      levelSummariesNotFound: 'Level summaries not found.',
      noDataFound: 'No data found.',
      noDataFoundForIds: 'No data found for the provided IDs.',
      noRegionsFound: 'No regions found.',
      notificationsServiceNotConfigured: 'The notifications service is not configured.',
      operationNotFound: 'Operation not found.',
      organizationDoesNotExist:
        'The organization does not exist. No new users can be registered at this time.',
      ownDevicesOnly: 'You can only register devices for your own account.',
      reportRequestTimedOut:
        'The request timed out while generating the report. Please, try again later.',
      requestBodyRequired: 'Request body is required.',
      requestCanceled: 'The request was cancelled. Please, try again later.',
      requestCanceledRetry: 'The request was cancelled. Please, try again later.',
      requestCannotBeNull: 'The request cannot be empty.',
      requestNotProcessed: 'The request did not process successfully. Please, try again later.',
      schoolAndTeacherIdRequired: 'School ID and Teacher ID are required.',
      schoolIdRequired: 'School ID is required.',
      schoolNotFound: 'School not found.',
      searchQueryRequired: 'Search query is required.',
      studentCreationTimedOut:
        'The request timed out while creating students. The operation may still be processing — please wait a moment and refresh to verify.',
      studentDataNotFoundOrDenied: 'Student data not found or access is denied.',
      studentProgressNotFound: 'Student progress data not found.',
      studentReportNotFound: 'Student report not found.',
      studentRequestRequired: 'The student request cannot be empty.',
      studentsNotFound: 'Students not found.',
      studentsReportNotFound: 'Students report not found.',
      studentsReportTimedOut:
        'The request timed out while retrieving the students report. Please, try again later.',
      teacherDetailsNotFound: 'Teacher details not found.',
      teacherIdRequired: 'Teacher ID is required.',
      teacherNotFound: 'Teacher not found.',
      teachersNotFound: 'Teachers not found.',
      teachersReportNotFound: 'Teachers report not found.',
      teachersReportTimedOut:
        'The request timed out while retrieving the teachers report. Please, try again later.',
      tokenCreationFailed: 'Token creation failed. Please, try again later.',
      unableToParseServerResponse:
        "Unable to parse the server's response. Students may have been created — please refresh and verify.",
      unableToProcessRequest: 'Unable to process your request. Please, try again later.',
      unableToRetrieveGroupsReport:
        'Unable to retrieve the groups report. Please check your request and try again.',
      unableToRetrieveStudentsReport:
        'Unable to retrieve the students report. Please check your request and try again.',
      unableToRetrieveTeachersReport:
        'Unable to retrieve the teachers report. Please check your request and try again.',
      unauthorized: 'Action unauthorized.',
      unexpectedDealServiceResponse: 'Unexpected response from the deal service.',
      unexpectedWithRef:
        'An unexpected error occurred. Please try again or contact support. (Ref: {{ref}})',
      unregisterOwnDevicesOnly: 'You can only unregister your own devices.',
      updateRequestBodyRequired: 'The update request body is required.',
      updatesRequired: 'Updates are required.',
      userAuthContextRequired: 'User authentication context is required.',
      userDoesNotExist: 'The requested user does not exist.',
      userIdentityRequired: 'User identity is required.',
      userNotFound: 'User not found.',
      userOrgDetailsNotFound: 'User organization details not found.',
      userPartiallyDeleted:
        'User deleted only from some systems, but not from all. Please try again or contact support.',
      validTeacherOrgIdRequired: 'A valid Teacher ID and Organization ID are required.',
      verificationCodeInvalid: 'The verification code is invalid.',
    },
    somethingWentWrong: 'משהו השתבש. נא לנסות שוב מאוחר יותר',
    wafBlocked: {
      description:
        'This action has been temporarily blocked for security reasons. Please try again in a few minutes.',
      eyebrow: 'Access Blocked',
      title: 'Oops...',
    },
    weHadAProblem: 'אופס, הייתה לנו בעיה',
  },
  exampleEmail: 'example@gmail.com',
  exampleSentences: 'דוגמאות שימוש',
  examples: 'דוגמאות',
  exit: 'יציאה',
  exploreEngaging:
    'מזמינים אותך ליהנות ממגוון שיעורים מרתקים ופעילויות מהנות כדי ללמוד אנגלית בהנאה וביעילות.',
  extra: 'תוספת',
  extraCoins: 'מטבעות נוספים',
  failed_quiz_message_first: 'למרבה הצער לא עברת, לכן לא קיבלת כוכבים.',
  failed_quiz_message_passed: 'לא עברת. אל דאגה, הציון הקודם שקיבלת נשמר.',
  failureRate: 'אחוז כישלון',
  fewMoreSeconds: 'רק עוד כמה שניות',
  fieldIsMandatory: 'נא למלא את השדה הזה',
  filter: 'סינון',
  finalAssessment: 'הערכה סופית',
  finalEnglishLevelTest: 'מבחן סוף רמה באנגלית',
  finishActivity: 'סיום הפעילות',
  finishGameText:
    'השלמת את הקורס של  Hello Britannica.<br/> כל הפעילויות הקודמות יישארו פתוחות עבורך, כך שאפשר לחזור ולתרגל.\n',
  finishToLevelUp: 'סיימו והתקדמו!',
  finishUnitSuccessText:
    'השלמת את היחידה {{completedUnitName}}. <br/> עכשיו אפשר להתחיל את היחידה {{nextUnitName}}. תמיד אפשר לחזור ליחידה זו כדי לעבור על מה שכבר תרגלת.',
  firstLogin: 'התחברות ראשונה',
  firstname: 'שם פרטי',
  focus: 'יצאת מפוקוס?',
  for: 'בשביל',
  forgotPassword: 'שכחתי סיסמה',
  fridayShort: "ו'",
  from: 'מ',
  fullVersionAvilableOnlyOnDesktop: 'הגרסה המלאה זמינה רק במחשב',
  generateClassReport: 'יצירת דו"ח כיתתי',
  generateReport: 'יצירת דו"ח',
  genericTable: {
    bimloaFilter: {
      all: 'הכול',
      close: 'סגירה',
      from: 'מ:',
      reset: 'איפוס',
      resetAll: 'איפוס הכול',
    },
    dropDown: {
      placeholder: 'בחירה',
    },
    noResultsForSearch: 'לא נמצאו תוצאות עבור החיפוש או הסינון שלך.',
  },
  getApp: 'להורדת האפליקציה',
  getFullExperience: 'מוזמנים להשלים את חוויית הלימוד עם אפליקציית Hello Britannica.',
  getStarted: 'נתחיל',
  giveFeedback: 'כתבו לנו',
  goAheadAndShareThisLinkWithYourStudentsNow: 'עכשיו אפשר לשתף את הקישור הזה עם התלמידים שלך.',
  goBack: 'חזרה',
  goForward: 'קדימה',
  goToLevelTest: 'מבחן רמה',
  go_back_btn: "כפתור 'חזרה'",
  goodAfternoon: 'צוהריים טובים',
  goodEvening: 'ערב טוב',
  goodJob: 'יפה מאוד',
  goodLuck: 'בהצלחה!',
  goodMorning: 'בוקר טוב',
  goodNight: 'לילה טוב',
  googleDataAdded: 'הכיתות שבחרת נוספו בהצלחה!',
  googleDataAddedDescription:
    'לאחר שהתלמידים שלך יתחברו למערכת, עליהם לעבור מבחן רמה. הם ישובצו ברמה המתאימה לפי תוצאות המבחן, ויתחילו את המסע ללימוד אנגלית.',
  googleDataSynced: 'הנתונים שלך סונכרנו!',
  googleDataSyncedDescription: 'כל הנתונים מסונכרנים כעת בין Google Classroom ל- Hello.',
  googleStudentIsInactive:
    'התלמיד או התלמידה אינם במצב פעיל. הם הוזמנו לכיתה, אך טרם התחילו את מבחן הרמה הראשוני.',
  googleStudentsAlreadyInOtherGroups:
    'לא הייתה אפשרות להוסיף את התלמידים הבאים לכיתה, מכיוון שהם כבר שייכים לכיתה אחרת:',
  grade: 'שכבה',
  grade_1: "א'",
  grade_10: "י'",
  grade_11: 'י״א',
  grade_12: 'י״ב',
  grade_13: 'אוניברסיטה',
  grade_14: 'אחר',
  grade_2: "ב'",
  grade_3: "ג'",
  grade_4: "ד'",
  grade_5: "ה'",
  grade_6: "ו'",
  grade_7: "ז'",
  grade_8: "ח'",
  grade_9: "ט'",
  grade_none: 'אחר',
  grade_university: 'אוניברסיטה',
  grammar_tip: 'הסבר',
  great: 'יופי!',
  greatJob: 'כל הכבוד!',
  guides: 'הוראות שימוש',
  hello: 'שלום',
  helloBritannica: 'Hello Britannica',
  helloLoader: 'Hello',
  helloTeacher: 'שלום 👋🏻',
  help: 'עזרה',
  hi: 'היי',
  hints: 'עזרה',
  hints_options: {
    add_more_time: 'הוספת זמן',
    hear_the_english_word: 'השמעת המילה',
    remove_a_letter: 'צמצום אותיות',
    remove_one_answer: 'צמצום תשובות',
    reveal_a_pair: 'חשיפת זוג קלפים',
    see_the_translation: 'הצגת התרגום',
    see_the_word: 'הצגת המילה',
    show_a_letter: 'הצגת אות',
  },
  homepage: 'לדף הבית',
  howDidYouDo: 'מהי ההערכה שלך?',
  howsYourEnglish: 'מהי רמת האנגלית שלך?',
  iAgree: 'נכון',
  iAgreeTo: 'אישור',
  iAmReady: 'אני רוצה להתחיל!',
  iDidntUnderstand: 'לא הבנתי. נא לנסות שוב.',
  iDoNotAgree: 'לא נכון',
  id: 'מספר אישי',
  illDoItLater: 'מאוחר יותר',
  importClasses: 'ייבוא כיתה',
  importYourFirstClass: 'ייבוא הכיתה הראשונה שלך מ- Google Classroom!',
  importYourFirstClassDescription:
    'אפשר לייבא את הכיתה שלך מ-Google Classroom ל-Hello, ואז התלמידים שלך יוכלו להצטרף',
  improveYourLastActivities: 'שיפור הציון בפעילויות האחרונות',
  in_order_to_start: 'כדי להתחיל את הלמידה שלך, עלינו לדעת',
  inactive: 'במצב לא פעיל',
  incorrect: 'לא נכון',
  incorrect_answer: 'שגויה',
  initialLevelTest: 'מבחן רמה ראשוני',
  interfaceLanguage: 'שפת ממשק',
  interface_language: 'שפת ממשק',
  invalidCode: 'קוד לא תקין',
  invalidEmail: 'כתובת המייל אינה תקינה',
  invalidEmailOrUsername: 'כתובת דוא"ל או שם משתמש לא חוקיים',
  invalidField: 'שגיאה בשדה זה',
  invalidFirstname: 'שגיאה בשם הפרטי',
  invalidLastname: 'שגיאה בשם המשפחה',
  invalidOrganizationName: 'School name contains invalid characters.',
  invalidPassword: 'הסיסמה אינה לפי הדרישות',
  invalidUsername:
    'שם המשתמש יכול להכיל רק אותיות, מספרים ואת הסמלים האלה: _ . - בלי רווחים. מקסימום 20 תווים.',
  invalidUsernameOrPassword: 'שם משתמש או סיסמה שגויים',
  invalidUsernameinForgotPassword:
    'משהו השתבש בשם המשתמש שלך "{{username}}". נא ליצור קשר עם המורה שלך לקבלת עזרה.',
  invitationLink: 'קישור להזמנה',
  invitationLinkWontChange: 'אל דאגה - הקישור להזמנה לא ישתנה',
  inviteYourStudents: 'הזמנת התלמידים שלך',
  inviteYourTeachers: 'נא להזמין מורות ומורים להצטרף ל- ',
  invitedToJoin: 'קיבלת הזמנה לצרף את בית הספר שלך ל-Hello  Britannica.\n',
  invitedToJoinMorfix: 'קיבלת הזמנה להצטרף ל- Hello Britannica',
  isNotEnglish: 'בפעילות הזאת צריך לכתוב באנגלית. נא לנסות שוב.',
  itLooksLikeYourLevel: 'נראה שהרמה המתאימה לך כעת היא {{level}}. כדאי להמשיך לתרגל כדי להשתפר!',
  itLooksLikeYourLevelMax: 'מצוין! נראה שהרמה המתאימה לך כעת היא {{level}}. בואו נתחיל.',
  itsTime: 'הגיע הזמן לבחור אם להתחיל את החידון,',
  joinNow: 'להצטרפות',
  keepGoing: 'קדימה',
  keepPlaying: 'כדאי להמשיך לשחק!',
  keepPracticing: 'המשיכו לתרגל',
  know: 'ידוע לי',
  know_your_level: 'את רמת האנגלית שלך.',
  language: 'שפה',
  language_of_study: 'שפת לימוד',
  languages: {
    ar: 'ערבית',
    en: 'אנגלית',
    es: 'ספרדית',
    he: 'עברית',
    pt: 'פורטוגלית',
  },
  lastLogin: 'התחברות אחרונה',
  lastUncorrectPronounce: 'לדלג לשאלה הבאה.',
  lastUnitCongratulation:
    'השלמת את הרמה <strong> {{currentLevel.name}} </strong> <br/>.  עכשיו אפשר להתקדם לרמה <strong>{{nextLevel.name}}</strong>.',
  lastname: 'שם משפחה',
  learn: '{{lessons}} שיעורים זמינים',
  leave_level_test_and_sign_out: 'רוצה לעזוב את מבחן הרמה?',
  letsAssess:
    'נבדוק את רמת האנגלית הנוכחית שלך בחידון קצר, כדי שנוכל להציע לך את חוויית הלמידה הטובה ביותר. החידון יימשך 5-15 דקות בהתאם לביצועים שלך. שנתחיל?',
  letsBegin: 'נתחיל',
  letsFinish: 'נסיים',
  letsGo: 'קדימה',
  letsKeepLearning: 'נמשיך ללמוד!',
  letsSee: 'כך אפשר לבדוק את מידת השליטה שלך במילים בנושא הזה.',
  level: 'רמה',
  levelChanged: 'הרמה שלך השתנתה',
  levelChangedDescription:
    'לתשומת ליבך: ההתקדמות והפעילות הקודמות שלך נמחקו כדי לשקף את מסלול הלמידה החדש שלך',
  levelChangedDown: 'רמת הלימוד שלך שונתה על-ידי המורה שלך',
  levelChangedDownDescription:
    'המטרה היא לעזור לך לחזק מיומנויות חשובות לפני שנוכל להמשיך - בהצלחה.',
  levelChangedUp: 'שודרגת על-ידי המורה שלך לרמת לימוד גבוהה יותר.',
  levelChangedUpDescription: 'כל הכבוד על ההתקדמות ובהצלחה בהמשך הלמידה!',
  levelName_1: 'טרום-בסיסית (Pre-A1)',
  levelName_2: 'בסיסית (A1)',
  levelName_3: 'טרום-בינונית (A2)',
  levelName_4: 'בינונית (B1)',
  levelName_5: 'בינונית-גבוהה (B2)',
  levelName_6: 'Advanced (C1)',
  levelTest: 'מבחן רמה',
  levelTestIncomplete: 'מבחן הרמה לא הושלם',
  levelTestPausedDescription: '{{count}} השאלות האחרונות לא יישמרו ויהיה צורך לחזור עליהן שוב.',
  level_test: 'מבחן רמה',
  linkCopied: 'הקישור הועתק',
  listen_tip: 'טיפ בהקשבה',
  listeningTapToFinish: 'לחצו כדי לשלוח',
  loginFromDifferent: 'התחברות מחשבון אחר',
  logout: 'יציאה מהחשבון',
  longClassName: 'שם הכיתה מוגבל לאורך של עד 40 תווים.',
  melingoCalculateYourLevel: 'אנחנו מחשבים את הרמה שלך...',
  memoryGameTitle: 'הפכו את הקלפים כדי להתאים שישה זוגות של מילים ותמונות.',
  menu_button: 'כפתור התפריט',
  message: 'הודעה',
  mgWebsite: {
    loginFormButton: 'להמשיך עם גוגל',
    loginFormSubTitle:
      '<div>אפשר ללחוץ על הקישור למטה כדי להתחבר לאתר עם החשבון</div>\n<div>שלך ב-Google - זה מהיר, פשוט ובטוח! </div>',
    loginFormTitle: 'היי, טוב לראות אותך!',
  },
  microphoneRestricted: 'הגישה למיקרופון מוגבלת בדפדפן שלך',
  missingGooglePermissionsPopup: {
    button: 'עדכון הרשאות',
    description: 'אחרי האישור שלך, יתאפשר לך להתחיל את מסע הלימוד שלך עם Hello!',
    title: 'נא לאפשר גישה ל"Hello"',
  },
  mondayShort: "ב'",
  months: {
    apr: 'Apr',
    aug: 'Aug',
    dec: 'Dec',
    feb: 'Feb',
    jan: 'Jan',
    jul: 'Jul',
    jun: 'Jun',
    mar: 'Mar',
    may: 'May',
    nov: 'Nov',
    oct: 'Oct',
    sep: 'Sep',
  },
  multiSelectDropDown: {
    loadMore: 'טעינת עוד נתונים',
    loading: 'טוען…',
    noResults: 'לא נמצאו תוצאות',
    removeAll: 'מחיקת הכול',
    selected: 'נבחרו',
    typeText: 'הקלידו טקסט כדי לחפש נתונים',
  },
  myPrivateTutor: 'המורה הפרטי שלי',
  myProfile: 'הפרופיל שלי',
  myProgress: 'ההתקדמות שלי',
  myProgressCompletedNotice:
    'Congratulations! Your assigned level is complete. Revisit these activities anytime for more practice.',
  my_tutor_page: {
    avatarLabel: 'AI-generated',
    commonMistakeDescription:
      'אפשר לתרגל בעזרת חידונים לשיפור האנגלית או לראות את הטעויות הרלוונטיות שלך מתוך השיחה',
    commonMistakes: 'תובנות לשוניות',
    completedActivities: '{{numberOfCompletedActivities}} הושלמו! כל הכבוד! 🏆',
    filterOptions: {
      enhancementArea: 'סוג הטעות',
      enhancementAreaSearchPlaceholder: 'חיפוש סוג טעות',
      score: 'ציון',
      status: 'סוג הפעילות',
      statusSearchPlaceholder: 'חיפוש סוג פעילות',
    },
    group: {
      filters: {
        all: 'הכול',
        currentDate: 'בחירת תאריך',
        date: 'תאריכי השיחות',
        last7days: 'ב-7 הימים האחרונים',
        level: 'רמה נוכחית',
        rangeDate: 'טווח',
        topic: 'נושאים',
      },
      table: {
        avgConversationTime: 'זמן שיחה ממוצע',
        conversation: 'שיחות',
        lastConversation: 'השיחה האחרונה',
        lastTopic: 'הנושא האחרון',
        level: 'רמה נוכחית',
        name: 'שם התלמיד/ה',
        noResultsMessage: 'לא נמצאו תוצאות עבור החיפוש או הסינון שלך.',
        title: 'תלמידים',
        topics: 'נושאים',
      },
    },
    jumpBackInSubtitle: 'You did great — now you can try again and get even better!',
    learn1: 'נותרו {{lessons}} מתוך {{totalLessonsCount}} חידונים',
    learnN: 'נותרו {{lessons}} מתוך {{totalLessonsCount}} חידונים',
    letsPractice: 'בואו נתרגל!',
    myDashboard: 'התקדמות',
    noActivities:
      '"Let’s talk so I will be able to know your needs and suggest practice accordingly! 😊',
    practiceBtn: 'תרגול',
    practiceCount: 'You have {{count}} practice suggestion',
    practiceCountPlural: 'You have {{count}} practice suggestions',
    quizStatus: {
      COMPLETED: 'הושלם',
      IMPROVEMENT: 'שיפור',
      PRACTICE: 'תרגול',
    },
    repeatTopic: 'Repeat Topic',
    report: {
      avgConversationDuration: 'משך זמן ממוצע',
      avgMistakes: 'מספר תיקונים ממוצע',
      cefr: 'CEFR',
      conversation1: 'שיחה {{numberOfConversations}}',
      conversationLevel: 'רמה',
      conversationSummary: 'סיכום שיחה',
      conversationsN: '{{numberOfConversations}} שיחות',
      description: 'תיאור',
      duration: 'משך זמן',
      errorsFound: 'טעית בנושא הזה {{errors}} פעמים',
      evaluationSummary: 'Conversation Evaluation',
      topicOfConversation: 'נושא השיחה',
      totalConversations: 'סך כל השיחות',
      watchHistory: 'מעבר חוזר על השיחה',
    },
    score: 'ציון',
    seeMyChatsBtn: 'הצגת הכול >',
    showMoreHistory: '+להראות יותר',
    sortOptions: {
      createdDateAscending: 'תאריכים, מהישן לחדש',
      createdDateDescending: 'תאריכים, מהחדש לישן',
      rankAscending: 'דירוג, מהנמוך לגבוה',
      rankDescending: 'דירוג, מהגבוה לנמוך',
      scoreAscending: 'ציון, מהנמוך לגבוה',
      scoreDescending: 'ציון, מהגבוה לנמוך',
      statusAscending: 'סטטוס, מ"לתרגול" ועד "\'הושלם"',
      statusDescending: "סטטוס, מ'הושלם' ועד 'לתרגול'",
      topicAscending: 'נושא (A-Z)',
      topicDescending: 'נושא (Z-A)',
    },
    statistics: {
      averageConversationTime: '⏱️ זמן שיחה ממוצע',
      filter: {
        month: 'ב-30 הימים האחרונים',
        rangeDate: 'בורר תאריכים מותאם אישית',
        staticTitle: 'הצגת נתונים של:',
        week: 'בשבוע הזה',
      },
      studentsUsingTutor: '💬 תלמידים המשתמשים במורה הפרטי',
      totalStudents: '👤 סך כל התלמידים',
    },
    youCanDoIt: '🚀 שיחקת אותה!',
    youHas1Chat: 'יש לך שיחה אחת',
    youHasNChat: 'יש לך {{numberOfConversations}} שיחות',
    yourChats: 'Your Chats',
  },
  nameAndStatus: 'שם וסטטוס',
  needHelp: 'עזרה',
  new_password: '‏‎סיסמה חדשה‎‏',
  new_password_verification: 'אישור הסיסמה החדשה',
  next: 'הבא',
  nextPage: 'לעמוד הבא',
  nextQuestion: 'לשאלה הבאה',
  nextQuiz: 'לפעילות הבאה',
  nextWord: 'למילה הבאה',
  niceEffort: 'כל הכבוד על המאמץ,',
  noClassToImport: 'אין כיתות לייבא',
  noClassToImportDescription:
    'תחילה יש ליצור את הכיתות שלך בדף שלך ב-Google Classroom https://classroom.google.com/ ואחר כך תוכל לייבא את התלמידים שלך לכאן',
  noExtraCoins: 'אין תוספת מטבעות',
  noLevelAssignedMessage: 'Please ask your teacher to set your level so you can start.',
  noLevelAssignedTitle: "You don't have a level assigned yet.",
  noLongerAvailable: 'הכיתה אינה זמינה עוד — נמחקה ב-Google Classroom',
  noStudentMistake: 'אם בכל זאת יש לך תלמידים בכיתה זו, נא לפנות להנהלת בית הספר שלך. ',
  noStudents: 'אין תלמידים בכיתה זו',
  noTrailingSpaces: 'נא לוודא שאין רווחים אחרי השם',
  none: 'אחר',
  notAvailable: 'לא קיים',
  notFoundError: 'שגיאת 404',
  notMadeIt: 'נראה שלא הצלחת בפעם הזאת. אפשר',
  notifications: {
    event: {
      accountDeleted: {
        body: 'Your Hello account has been deleted.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your Hello account has been deleted.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your Hello account has been deleted.',
        title: 'Your account has been deleted.',
      },
      adminDealExpired: {
        body: 'Your school’s Hello Britannica subscription has expired. Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        title: 'Your school’s Hello Britannica subscription has expired',
      },
      assignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      classDeleted: {
        body: '{{className}} has been deleted.',
        title: 'Your class has been deleted',
      },
      classGradeEdited: {
        body: 'The grade for {{className}} has been changed from {{oldGradeStr}} to {{newGradeStr}}.',
        title: 'Your class grade has been updated',
      },
      classNameEdited: {
        body: '{{oldClassName}} has been renamed to {{newClassName}}.',
        title: 'Your class has been renamed',
      },
      classesDeleted: {
        body: '{{numberOfClasses}} classes have been deleted.',
        body_one: '1 class has been deleted.',
        title: 'Your classes have been deleted',
      },
      coTeacherAdded: {
        body: '{{teacherFullName}} was assigned to your class {{className}}.',
        title: 'Co-Teacher was added to your class',
      },
      coTeacherAssignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      coTeacherRemoved: {
        body: '{{teacherFullName}} was removed from your class {{className}}.',
        title: 'Co-Teacher was removed from your class',
      },
      dealDateExpirationUpdated: {
        body: 'Your school’s Hello Britannica subscription expiration date has been updated to {{dateStr}}.',
        title: 'Expiration date changed for your school’s Hello Britannica subscription',
      },
      interfaceLanguageChanged: {
        body: 'Your interface language has been changed to {{newLanguageStr}}.',
        title: 'Your interface language has been updated',
      },
      levelChanged: {
        body: 'Your English level has been changed from {{oldLevel}} to {{newLevel}}.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        title: 'Your level has been updated',
      },
      levelTestNotFinished: {
        body: 'Come back and finish a few more questions to begin practicing with Hello Britannica.',
        title: 'Say "Hello" to learning English',
      },
      levelTestNotTaken: {
        body: 'Check your English with a short quiz to unlock activities.',
        title: 'Get started with Hello Britannica',
      },
      licenseLimitReached: {
        actionText:
          'To extend your subscription with additional licenses, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        body: 'Your school has reached its license limit. No additional students can be registered. Please contact Hello Britannica support to add more licenses.',
        title: 'License limit reached',
      },
      movedToDifferentClass: {
        body: 'You have been moved from {{oldClassName}} to {{newClassName}}.',
        title: "You've been moved to a new class",
      },
      movedToDifferentClassWithLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'You were assigned to a new class',
      },
      movedToDifferentClassWithPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'You were assigned to a new class',
      },
      nameChanged: {
        body: 'Your name has been updated to {{newFullName}}.',
        title: 'Your name has been updated',
      },
      removedFromClass: {
        body: 'You have been removed from {{className}}.',
        title: "You've been removed from a class",
      },
      studentAdvancedToNewLevel: {
        body: '{{studentFullName}} from {{className}} has advanced from {{oldLevel}} to {{newLevel}}.',
        title: 'A student reached a new level',
      },
      studentDealExpired: {
        body: 'Access to Hello Britannica has ended for your school. Please contact your teacher or school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Platform access has ended',
      },
      studentDeleted: {
        body: '{{studentFullName}} has been deleted from {{className}}.',
        title: 'A student has been deleted from your class',
      },
      studentGroupAllowIndividualAdvancement: {
        body: 'You will now advance to the next level.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentInactivityDigest1m: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past month.',
        body_one: '1 student has not engaged in Hello Britannica in the past month.',
        title: 'Assign your students activities to complete in Hello Britannica',
      },
      studentInactivityDigest2w: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past two weeks.',
        body_one: '1 student has not engaged in Hello Britannica in the past two weeks.',
        title: 'Encourage your students to practice English with Hello Britannica',
      },
      studentWeeklyInactivity: {
        body: 'You scored {{lastCompletedActivityScore}} on your last Hello Britannica activity. Can you beat it?',
        body_noScore:
          "You haven't completed any Hello Britannica activity yet. Why won't you try it?",
        title: 'Don’t forget to practice your English today!',
      },
      studentsAssignedToClassByAdmin: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} students have been added to {{className}}.',
        body_one: '1 student has been added to {{className}}.',
        title: 'Students have been added to your class',
      },
      studentsDeleted: {
        body: '{{numberOfStudents}} students have been deleted from {{className}}.',
        body_one: '1 student has been deleted from {{className}}.',
        title: 'Students have been deleted from your class',
      },
      studentsJoinedSinceLastLoginWithOutStudents: {
        body: 'No students have joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedSinceLastLoginWithStudents: {
        body: '{{numberOfStudents}} students have joined your school since your last login.',
        body_one: '1 student has joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedViaTeacherInvitation: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} students have joined {{className}}.',
        body_one: '1 student has joined {{className}}.',
        title: 'A student has joined your class',
      },
      studentsLevelChangedByOperator: {
        body: '{{studentFullName}}’s English level has been changed from {{oldLevel}} to {{newLevel}}.',
        title: 'Your student’s level has been changed',
      },
      studentsMovedOutOfTheClass: {
        body: '{{numberOfStudents}} students have been moved from {{oldClassName}} to {{newClassName}}.',
        body_one: '1 student has been moved from {{oldClassName}} to {{newClassName}}.',
        title: 'Students moved out of the class',
      },
      teacherCreatedNewClass: {
        body: '{{className}} has been created.',
        title: 'A new class has been created',
      },
      teacherDealExpired: {
        body: 'Access to Hello Britannica has ended for you and your students. Please contact your school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Hello Britannica access has ended',
      },
      teacherDeletedClassWithOutStudents: {
        body: '{{className}} has been deleted.',
        title: 'A class has been deleted',
      },
      teacherDeletedClassWithStudents: {
        body: '{{className}} has been deleted. {{numberOfStudents}} students also were deleted.',
        body_one: '{{className}} has been deleted. 1 student also was deleted.',
        title: 'A class has been deleted',
      },
      topicCompletedLowScore: {
        body: '{{studentFullName}} completed a topic with scores lower than 70 in skills: {{skillsListStr}}.',
        body_one:
          '{{studentFullName}} completed a topic with a score lower than 70 in {{skillsListStr}}.',
        title: 'Your student may need extra help',
      },
      weeklyClassSummaryWithActivity: {
        body: 'Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level / {{numberOfStudentsCompletedUnit}} students completed a unit / {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted.',
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklyClassSummaryWithOutActivity: {
        body: "Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): nothing has changed this week. Encourage your students to practice their English with Hello Britannica regularly and you'll see them completing units in no time!",
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklySchoolSummaryWithActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted / {{numberOfTeachersHaveJoined}} teachers have joined / {{numberOfClassesWereCreated}} classes were created / {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
      weeklySchoolSummaryWithOutActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): nothing has changed this week. To get the most out of Hello Britannica, remind teachers to encourage their students to practice their English language skills regularly.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
    },
    list: {
      allNotificationsMessage: 'No more notifications from the last 30 days.',
      markAllAsReadButton: 'Mark all as read',
      noNotificationsMessage: 'No new notifications.',
      sendDataWithOperator: '{{createdAtStr}} | by {{operatorFirstName}} {{operatorLastName}}',
      sendDataWithoutOperator: '{{createdAtStr}}',
      title: 'Notifications',
    },
    popup: {
      okButton: 'OK',
    },
  },
  ofThisSite: 'של אתר זה.',
  offlineNotification: {
    button: 'OK',
    description: 'When you will be online again, you will be able to continue using the platform.',
    title: 'You are currently offline.',
  },
  ok: 'בסדר',
  okLetsGo: 'אוקיי, קדימה!',
  oneMoreMistake: 'אם תהיה לך עוד טעות, החידון יסתיים,',
  onlyNumbersAllowed: 'אפשר לכתוב רק מספרים',
  oops: 'אופס',
  oopsDots: 'אופס...',
  orClickHereToSendAgain: 'או <0> ללחוץ כאן </0> כדי לשלוח את הקוד שוב.',
  orLoginWithGoogle: 'או להמשיך עם Google Classroom',
  organizationNameTooLong: 'School name can be up to 70 characters.',
  outOf: 'מתוך',
  overallProgress: 'התקדמות כוללת',
  pageNotFound: 'הדף לא נמצא',
  partialImportError:
    'אי-אפשר לייבא חלק מהכיתות כי הן כבר יובאו בידי מורה אחר/ת. שאר הכיתות יובאו בהצלחה.',
  passRate: 'אחוז הצלחה',
  password: 'סיסמה',
  passwordMinimumLength: 'הסיסמה צריכה להיות באורך 8 תווים לפחות',
  password_changed_successfully: 'שינית בהצלחה את הסיסמה',
  passwordsDontMatch: 'הסיסמאות אינן תואמות.',
  pause_game: 'הפסקת החידון',
  paussed: 'הופסקה',
  phone: 'טלפון',
  pictureOfTheDay: 'תמונת היום',
  play_sound: 'השמעת קול',
  pleaseChooseYourOwnPassword: 'נא לבחור סיסמה משלך',
  pleaseEnterTheFollowing: 'נא למלא את הפרטים הדרושים כדי להתחיל',
  pleaseEnterYourDetails: 'נא להזין את הפרטים שלך',
  pleaseSelectYourAccount: 'נא לבחור את החשבון שלך או להתחבר מחשבון אחר',
  pleaseTakeAMoment: 'נא לרשום את בית הספר.',
  pleaseTryAgain: 'נא לנסות שוב.',
  practice: 'התחלת תרגול',
  practiceAgain: 'לתרגל שוב',
  practiceProperPronunciation:
    'מזמינים אותך לתרגל הגייה נכונה של מילים ומשפטים חדשים. יש ללחוץ על סימן המיקרופון הכחול ואז להגות את המילה הרצויה. אחרי שסיימת לדבר, יש ללחוץ שנית על סימן המיקרופון הכחול. יש לדבר לאט.',
  practiceYourVocabulary: 'תרגול אוצר מילים',
  preferences: 'העדפות',
  premiumSection: {
    description:
      'כאן אפשר לקבל מידע חשוב על מקורות לימוד מנציגי בית הספר שלך או מצוות Hello Britannica.',
    title: 'מסר למורים',
    unlock: 'עוד',
  },
  preparationAudioToImage:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך התאימו בינו לבין התמונה הנכונה.',
  preparationAudioToImageMobile:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך התאימו בינו לבין התמונה הנכונה.',
  preparationClosedSpelling:
    'שחקו בהנאה כדי לשפר את כישורי האיות. יש להתבונן בתמונה ולבחור את האותיות המתאימות להרכבת המילה. ',
  preparationClosedSpellingMobile:
    'שחקו בהנאה כדי לשפר את כישורי האיות. יש להתבונן בתמונה ולבחור את האותיות המתאימות להרכבת המילה. ',
  preparationDescriptionFirstPart:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך התאימו בינו לבין התמונה הנכונה.',
  preparationDescriptionFirstPartMobile:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך התאימו בינו לבין התמונה הנכונה.',
  preparationDescriptionSecondtPart: 'לומדים אנגלית בעזרת חידות מהנות!',
  preparationGrammar:
    'יש לקרוא את השאלה ולבחור את האפשרות הנכונה. חפשו את הטיפ עם ההסבר הדקדוקי! מוכנים? בואו נתרגל דקדוק באנגלית!',
  preparationGrammarMobile:
    'יש לקרוא את השאלה ולבחור את האפשרות הנכונה. חפשו את הטיפ עם ההסבר הדקדוקי! מוכנים? בואו נתרגל דקדוק באנגלית!',
  preparationImageToText: 'לומדים אנגלית ונהנים! התבוננו בתמונה והתאימו אותה לאפשרות הנכונה.',
  preparationImageToTextMobile: 'לומדים אנגלית ונהנים! התבוננו בתמונה והתאימו אותה לאפשרות הנכונה.',
  preparationListen:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך בחרו את התשובה הנכונה.',
  preparationListenMobile:
    'הקשיבו בכיף! לחצו על סימן הרמקול והקשיבו לקטע האודיו. אחר כך בחרו את התשובה הנכונה.',
  preparationMemory: 'משחקים בהנאה ומשפרים את אוצר המילים באנגלית! יש להתאים בין המילים לתמונות.',
  preparationMemoryMobile:
    'משחקים בהנאה ומשפרים את אוצר המילים באנגלית! יש להתאים בין המילים לתמונות.',
  preparationNaturalConversation:
    ' משפרים את כישורי הדיבור באנגלית! יש ללחוץ על סימן הרמקול ולהקשיב לקטע האודיו. יש לבחור את התשובה הנכונה. אחר כך יש ללחוץ על סימן המיקרופון הכחול ואז להגות את המילה הרצויה. אחרי שסיימת לדבר, יש ללחוץ שנית על סימן המיקרופון הכחול.',
  preparationNaturalConversationMobile:
    ' משפרים את כישורי הדיבור באנגלית! יש ללחוץ על סימן הרמקול ולהקשיב לקטע האודיו. יש לבחור את התשובה הנכונה. אחר כך יש ללחוץ על סימן המיקרופון הכחול ואז להגות את המילה הרצויה. אחרי שסיימת לדבר, יש ללחוץ שנית על סימן המיקרופון הכחול.',
  preparationOpenWriting:
    'הביעו את עצמכם בכתב! קראו את השאלה והתבוננו בתמונה. אחר כך כתבו את התשובה.',
  preparationOpenWritingMobile:
    'הביעו את עצמכם בכתב! קראו את השאלה והתבוננו בתמונה. אחר כך כתבו את התשובה.',
  preparationRead: 'קראו את הקטע ואחר כך ענו על השאלות. קדימה!',
  preparationReadMobile: 'קראו את הקטע ואחר כך ענו על השאלות. קדימה!',
  preparationSecondtPartGrammar: 'אל דאגה, במהלך המשחק יופיעו טיפים בדקדוק שיעזרו לך.',
  preparationSecondtPartImageToText: 'בהצלחה!',
  preparationSecondtPartSpeak: 'בהצלחה!',
  preparationSecondtPartTextToImage: 'בהצלחה!',
  preparationSecondtPartVocabulary:
    'כך אפשר לבדוק את מידת השליטה שלך במילים בנושא הזה. <b>\nבהצלחה!</b>',
  preparationSpeaking:
    'מזמינים אותך לתרגל הגייה נכונה של מילים ומשפטים חדשים. יש ללחוץ על סימן המיקרופון הכחול ואז להגות את המילה הרצויה. אחרי שסיימת לדבר, יש ללחוץ שנית על סימן המיקרופון הכחול. יש לדבר לאט.',
  preparationSpeakingMobile:
    'מזמינים אותך לתרגל הגייה נכונה של מילים ומשפטים חדשים. יש ללחוץ על סימן המיקרופון הכחול ואז להגות את המילה הרצויה. אחרי שסיימת לדבר, יש ללחוץ שנית על סימן המיקרופון הכחול. יש לדבר לאט.',
  preparationTextToImage: 'לומדים אנגלית בכיף! קראו את הטקסט ובחרו את התמונה הנכונה.',
  preparationTextToImageMobile: 'לומדים אנגלית בכיף! קראו את הטקסט ובחרו את התמונה הנכונה.',
  preparationTextToText:
    'לומדים בכיף מילים חדשות, דקדוק והבנת הנקרא! קראו את המשפטים או את השאלות ובחרו את התשובה הנכונה.',
  preparationTextToTextMobile:
    'יש לבחור בתשובה הנכונה להשלמת המשפטים הבאים כדי לשפר את כישורי הבנת הנקרא, אוצר המילים והדקדוק שלך.',
  preparationVocabulary: 'לומדים מילים חדשות! בצעו את ההוראות ובחרו באפשרות הנכונה.',
  preparationVocabularyMobile: 'לומדים מילים חדשות! בצעו את ההוראות ובחרו באפשרות הנכונה.',
  privateTutor: 'מורה פרטי',
  processing: 'בתהליך',
  profile: 'פרופיל',
  progress: 'התקדמות',
  provideClassCode: 'נא להזין את קוד הכיתה שלך',
  question: 'שאלה',
  questions: 'שאלות',
  questionsAndConcerns: 'העומדות לפניכם',
  questionsLeft: 'שאלות שנותרו',
  quiz: 'הפעילות',
  quizzes: 'חידונים',
  quizzesCompleted: 'חידונים שהשלמת',
  ran_out_of_time: 'שוב נגמר הזמן. השאלה תסומן כ',
  rateYourself: 'דירוג עצמי',
  readMore: 'עוד',
  readWithImageStartQuizInstructions: 'קראו את הקטע ואחר כך ענו על השאלות.',
  read_tip: 'טיפ בקריאה',
  readyToChooseYourAvatar: 'רוצה לבחור את האווטר שלך?',
  refresh: 'רענון',
  registrationDealExpiredMessageDescription: 'נא לפנות להנהלת בית הספר לקבלת הדרכה.',
  registrationDealExpiredMessageDescriptionAdmin:
    'Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
  registrationDealExpiredMessageDescriptionTeacher:
    'Please contact your school administrator for guidance.',
  registrationDealExpiredMessageTitle: 'פג תוקפו של הקישור שניסית להגיע אליו 😕',
  registrationDealLimitReachedMessageDescription: 'נא לפנות להנהלת בית הספר לקבלת הדרכה.',
  registrationDealLimitReachedMessageTitle: 'בית הספר הגיע לגבול מכסת המשתמשים בעסקה שלו 😕',
  reports: {
    activitiesCompletedInLevel: 'פעילויות שהושלמו ברמה {0}',
    allLevelsAvgTime: '📊 זמן ממוצע בכל הרמות',
    attemptsAndHints: 'ניסיונות ורמזים',
    averagePerSkill: 'ממוצע לכל מיומנות',
    avgActivitiesCompleted: 'ממוצע הפעילויות שהושלמו',
    avgAttempts: 'מספר ניסיונות ממוצע',
    avgAttemptsPerActivity: 'מספר ניסיונות ממוצע לכל פעילות',
    avgFailureRate: 'אחוז כישלון ממוצע',
    avgHintsPerActivity: 'מספר רמזים ממוצע לכל פעילות',
    avgPassRate: 'אחוז הצלחה ממוצע',
    avgPerWeek: 'ממוצע לשבוע',
    avgSkillScores: 'ממוצע ציונים בכל מיומנות',
    avgStreakLength: 'אורך ממוצע של רצף התרגול',
    avgStreakPerWeek: 'רצף תרגול ממוצע לשבוע',
    avgStudentProgress: 'ממוצע התקדמות התלמידים',
    avgTimeSpent: 'זמן ביצוע ממוצע',
    continuousEngagement: 'פעילות ממושכת',
    daysPerWeek: '{0} ימים בשבוע',
    engagedStudentsWord_one: 'engaged student',
    engagedStudentsWord_other: 'engaged students',
    engagement: 'פעילות במערכת',
    failureRate: 'אחוז כישלון',
    inCurrentLevel: 'ברמה הנוכחית',
    longestStreak: 'רצף התרגול הארוך ביותר',
    onActivities: 'בפעילויות',
    overallProgressInLevel: 'התקדמות כוללת ברמה {0}',
    passRate: 'אחוז הצלחה',
    perActivity: 'לכל פעילות',
    perLevel: 'לכל רמה',
    previous7Days: '7 הימים הקודמים',
    progress: 'התקדמות',
    remark: '*נתונים אלו הם לפי מספר של<b>{0}</b> תלמידים פעילים מתוך {1} תלמידים בכיתה זו.',
    skippedActivitiesComment: '* פעילויות שדילגו עליהן נכללות בסך כל הפעילויות',
    streakLast7Days: 'רצף התרגול במהלך 7 הימים האחרונים',
    streakLength: 'אורך רצף התרגול',
    studentsOnlyWord_one: 'student',
    studentsOnlyWord_other: 'students',
    timeSpentOnActivites: 'הזמן שהושקע בפעילויות',
    total: 'סה"כ',
    totalHintsUsed: 'מספר הרמזים',
    totalInPrev7Days: 'סה"כ ב-7 הימים הקודמים',
    totalStudents: 'סך כל התלמידים',
  },
  requirements: 'דרישות',
  resendVerificationCode: 'לא קיבלת? שלחו אליי שוב את הקוד',
  resetPassword: 'איפוס סיסמה',
  resetPasswordRequest: 'בקשה לאיפוס סיסמה נשלחה למורה שלך!',
  resolved: 'טוב, שיניתי את ההגדרות!',
  results: 'תוצאות',
  resume: 'המשך',
  review: 'משוב',
  reward: 'פרס',
  saturdayShort: "ש'",
  save: 'שמירה',
  schoolName: 'שם בית הספר',
  score: 'ציון',
  scrollToTop: 'גלילה למעלה',
  searchClasses: 'חיפוש ו/או בחירת אפשרות',
  searchForStudent: 'חיפוש תלמידים',
  searchStatus: 'חיפוש סטטוס',
  selectAll: 'בחירת הכול',
  selfPracticeStreak: 'רצף התרגול שלי',
  send: 'שליחה',
  sendNow: 'שליחה',
  settings: {
    about_me: 'הפרטים שלי',
    add_students: {
      add_student: 'הוספת תלמידים',
      add_students_manually: 'הוספה ידנית',
      button_next: 'הבא',
      classCreatedDescriptionNoLevelTest:
        'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
      click_to_browse: 'ללחוץ כדי לחפש את הקובץ במחשב שלך',
      create_students: 'התלמידים הבאים יקבלו הזמנה בדוא"ל',
      download: 'הורדת',
      download_sample: 'קובץ xlsx לדוגמה.',
      drag_here: 'אפשר לגרור קבצים לכאן או ',
      email_will_be_send: 'דוא"ל עם סיסמה זמנית יישלח לתלמיד',
      enroll_students: 'רישום תלמידים',
      enrollment_unsuccessful: '⚠️ ההרשמה לא הצליחה!',
      enrollment_unsuccessful_description:
        'התלמידים הבאים לא הצליחו להירשם מכיוון שכבר נעשה שימוש בכתובת האימייל שלהם:',
      errors: {
        bad_formatting:
          'הנתונים בקובץ אינם תקינים.  <br/> יש לבדוק את הנתונים ולתקן אותם לפי הצורך',
        email_in_use: 'כתובת הדוא"ל הזאת כבר רשומה',
        email_incorrect: 'נא להזין כתובת דוא"ל חוקית.',
        file_empty: 'ניסית להעלות קובץ ריק',
        file_too_large: 'הקובץ גדול מדי. הגודל המרבי המותר הוא 256KB.',
        first_name_incorrect: 'השם הפרטי מכיל תווים לא חוקיים, או שהוא ארוך מדי.',
        first_name_missing: 'יש להזין שם פרטי.',
        first_name_too_long: 'השם הפרטי ארוך מדי.',
        last_name_incorrect: 'שם המשפחה מכיל תווים לא חוקיים, או שהוא ארוך מדי.',
        last_name_missing: 'יש להזין שם משפחה.',
        last_name_too_long: 'שם המשפחה ארוך מדי.',
        limit_reached:
          'המספר המרבי של תלמידים בכיתה הוא 50. <br/>נא להסיר את הקובץ ולהעלות קובץ חדש.',
        limit_reached_description: 'הכיתה שלך מכילה את מספר התלמידים המרבי המותר.',
        limit_reached_title: 'הכיתה הזאת כבר מלאה.',
        max_number_of_students:
          'המספר המרבי של תלמידים בכיתה הוא 50. <br/> נא להסיר את הקובץ ולהעלות קובץ חדש.',
        students_not_registered: 'חלק מהתלמידים לא נרשמו',
        username_invalid: 'שם המשתמש הזה כבר תפוס',
        username_missing: 'יש להזין שם משתמש',
        wrong_format: 'הפורמט של הקובץ אינו נכון. . \n<br/>נא לוודא שהעלית קובץ xlsx.',
      },
      invite_students: 'הזמנת תלמידים',
      not_enough_licenses_blocked_one:
        "Your request to add 1 student has been blocked because your school's license limit cannot accommodate them.",
      not_enough_licenses_blocked_other:
        "Your request to add {{requested}} students has been blocked because your school's license limit cannot accommodate them all.",
      not_enough_licenses_remaining_one:
        'There is only 1 seat remaining. You may invite fewer students to fill the remaining seat or contact us for assistance.',
      not_enough_licenses_remaining_other:
        'There are only {{available}} seats remaining. You may invite fewer students to fill the remaining seats or contact us for assistance.',
      not_enough_licenses_teacher_blocked_one:
        "Your request to add 1 student has been blocked because your school's user limit cannot accommodate them.",
      not_enough_licenses_teacher_blocked_other:
        "Your request to add {{requested}} students has been blocked because your school's user limit cannot accommodate them all.",
      not_enough_licenses_teacher_remaining_one:
        'There is only 1 seat remaining. You may invite fewer students to fill the remaining seat or contact your school administrator for guidance.',
      not_enough_licenses_teacher_remaining_other:
        'There are only {{available}} seats remaining. You may invite fewer students to fill the remaining seats or contact your school administrator for guidance.',
      partial_success: '⚠️ הצלחה חלקית',
      partial_success_description:
        '{{addedStudents}} מִתוֹך {{totalStudents}} תלמידים נרשמו בהצלחה לכיתה זו.<br/> נשלח להם אימייל עם הסיסמה הזמנית שלהם.',
      upload_attention_text:
        '⚠️ בכיתה שלך יש {{curent}}/{{limit}} תלמידים. <br/>ניתן לרשום {{certified}} תלמידים נוספים.',
      upload_attention_text_new_class: '⚠️ מקסימום {{limit}} תלמידים בכיתה',
      upload_file: 'העלאת קובץ האקסל של התלמידים שלך',
      upload_successful: 'הקובץ שלך הועלה בהצלחה',
    },
    class: 'הכיתה שלי',
    current_level: 'רמה נוכחית:',
    delete_class: {
      areYouSure: 'בטוח שברצונך למחוק?',
      cancel: 'ביטול',
      classNotEmpty: 'אי-אפשר למחוק כיתה המכילה תלמידים.',
      classNotEmptyDescription:
        'אם ברצונך למחוק את הכיתה הזאת, תחילה יש למחוק את התלמידים האלה. כדי לעשות זאת, אפשר לפתוח את הפרופיל של התלמיד וללחוץ על סמל העריכה.',
      delete: 'מחיקה',
      deletingFailed: 'הייתה לנו בעיה טכנית.',
      deletingFailedDescription:
        'השרתים שלנו אינם מגיבים. נא לנסות שוב. אם הבעיה תימשך, נא ליצור איתנו קשר בכתובת \n<a href="mailto:{{email}}"> {{email}} </a>',
      description: 'מחיקת כיתה היא פעולה בלתי הפיכה.',
      tryAgain: 'ניסיון חוזר',
    },
    delete_student: {
      areYouSure: 'בטוח שברצונך למחוק?',
      cancel: 'ביטול',
      choose: 'בחירה',
      delete: 'מחיקה',
      deleteStudent: 'מחיקת תלמיד/ה',
      deletingFailed: 'המחיקה נכשלה.',
      deletingFailedDescription: '',
      description:
        'מחיקת התלמיד או התלמידה תסיר אותם לצמיתות מהמערכת. הם כבר לא יוכל להתחבר וכל נתוני ההתקדמות יימחקו. נא לציין את הסיבה למחיקה:',
      reason: 'סיבה',
      reasons: {
        aClericalError: 'טעות ברישום',
        other: 'אחר',
        requestedToBeRemoved: 'התלמיד או ההורה ביקשו הסרה מהמערכת',
      },
      why: 'למה?',
    },
    grade: 'כיתה',
    home: 'לדף הבית',
    interface_language: 'Interface language',
    language: 'שפה',
    logout: 'יציאה מהחשבון',
    my_classes: 'הכיתות שלי',
    my_games: 'החידונים שלי',
    my_students: 'התלמידים שלי',
    my_tutor: 'המורה הפרטי שלי',
    native_language: 'שפת אם',
    privacy_policy: 'מדיניות פרטיות',
    profile: 'פרופיל',
    school_id: 'בית הספר שלי',
    security: 'אבטחה',
    title: 'הגדרות',
    username: 'השם שלי',
  },
  setupYourClass:
    'יש להגדיר את הכיתה שלכם, ואז יתקבל קוד כיתה לשלוח לתלמידים שלך. הם יבצעו תהליך רישום מהיר, ואז יוכלו להצטרף לכיתה!',
  signIn: 'כניסה לחשבון',
  signYouIn: 'מתחבר לחשבון שלך...',
  sign_out: 'יציאה מהחשבון',
  sixDigits: '6 ספרות',
  sixDigitsAtLeast: 'הקוד חייב להיות בן 6 ספרות לפחות',
  skills: {
    grammar: 'דקדוק',
    listen: 'הקשבה',
    read: 'הבנת הנקרא',
    speak: 'דיבור והגייה',
    spelling: 'איות',
    vocabulary: 'אוצר מילים',
  },
  skip: 'דילוג',
  skipAllRecording: 'דילוג על כל ההקלטות',
  skipThisQuestion: 'דילוג על השאלה הזאת',
  skipped: 'דילגת',
  skippedPopUpSummary: {
    speak: {
      bannerTitle: 'דילגת',
      description: 'המערכת תדלג על פעילות זו ולא תקבל עליה ציון. אפשר לחזור אליה אחר כך.',
      title: 'בחרת לדלג על פעילות זו',
    },
  },
  somewhatAgree: 'לא לגמרי נכון',
  sortBy: 'מיון לפי:',
  soundAnalyzingSentences: {
    '0': 'אנחנו מנתחים את התשובה שלך, נא להמתין',
    '1': 'משימות דיבור יכולות לעזור לך ללמוד אנגלית טוב יותר',
    '2': 'כמעט סיימנו...',
    numberOfSentences: '3',
  },
  speak_tip: 'טיפ בדיבור',
  spelling_tip: 'טיפ באיות',
  stars: 'כוכבים',
  start: 'התחלה',
  startActivity: 'התחלת הפעילות',
  startLevelTest: 'התחלת המבחן',
  startNewConversation: 'התחלת שיחה חדשה',
  startQuiz: 'התחלת חידון',
  startSkippedActivities: 'התחלת הפעילויות שדילגנו עליהן',
  startingLevel: 'רמת התחלה',
  startingReward: 'פרס להתחלה',
  state: 'מחוז',
  status: 'מצב',
  studentInstructions: 'ההוראות לתלמידים',
  studentMetricsDashboard: {
    charts: {
      avgScores: {
        subTitle: 'לפי מיומנות',
        title: 'ציונים ממוצעים',
      },
      avgStudentGrowth: {
        subTitle: 'לחודש',
        title: 'גידול ממוצע במספר התלמידים',
        tooltipTitle: 'גידול ממוצע במספר התלמידים',
      },
      avgStudentProgressAtCurrentLevel: {
        levelInfo: 'רמה {{level}} ({{studentCount}} תלמידים)',
        subTitle: 'לכל רמה',
        title: 'התקדמות ממוצעת של תלמידים ברמה הנוכחית',
      },
      kpis: {
        averageTimeSpent: {
          label: '📊 זמן ביצוע ממוצע',
          tooltip: 'הזמן הממוצע שהתלמידים שיחקו במהלכו באופן פעיל.',
        },
        failureRate: {
          label: '🙁 אחוז כישלון',
          tooltip: 'אחוז הפעילויות שהתלמידים שיחקו בהן ושנכשלו, דילגו עליהן או לא השלימו אותן.',
        },
        passRate: {
          label: '✅ אחוז הצלחה',
          tooltip: 'אחוז הפעילויות שהתלמידים ניסו לבצע והצליחו בהן.',
        },
        studentsThatPassedLevel: {
          label: '🚀 תלמידים שעברו רמה',
          tooltip: 'מספר התלמידים שעברו לפחות רמה אחת.',
        },
        totalActivitiesPassed: {
          label: '🏆 סך כל הפעילויות שהתלמידים עברו בהצלחה',
          tooltip: 'מספר הפעילויות הייחודיות שהתלמידים עברו בציון 60 ומעלה.',
        },
        totalTimeSpent: {
          label: '⏰ סך כל זמן הביצוע',
          tooltip: 'סך כל הזמן שהתלמידים שיחקו במהלכו באופן פעיל.',
        },
      },
      studentLevelProgression: {
        levelInfo: 'רמה {{level}} ({{studentCount}} תלמידים)',
        subTitle: 'התקדמות התלמידים מרמת ההתחלה לרמה הנוכחית',
        title: 'התקדמות ברמת התלמידים',
        tools: {
          studentStartedAtL1: 'התחיל ב-L1',
          studentStartedAtL2: 'התחיל ב-L2',
          studentStartedAtL3: 'התחיל ב-L3',
          studentStartedAtL4: 'התחיל ב-L4',
          studentStartedAtL5: 'התחיל ב-L5',
          studentStartedAtL6: 'Started at L6',
        },
      },
      studentsAcrossSkills: {
        subTitle: 'לפי מיומנות',
        title: 'ביצועי תלמידים במיומנויות השונות',
        tools: {
          failure: 'כישלון (מתחת ל-60)',
          pass: 'הצלחה',
        },
      },
    },
    drillDown: {
      skills: {
        columns: {
          class: 'כיתה',
          classNameAndGrade: 'כיתה ושכבה',
          currentLevel: 'רמה נוכחית',
          grade: 'שכבה',
          name: 'שם מלא של התלמיד/ה',
          nameAndTeacher: 'שם ומורה',
          skillGrammar: 'ממוצע בדקדוק',
          skillListening: 'ממוצע בתחום ההקשבה',
          skillPronunciation: 'ממוצע בתחום ההגייה',
          skillReading: 'ממוצע בהבנת הנקרא',
          skillSpeaking: 'ממוצע בתחום הדיבור',
          skillSpelling: 'ממוצע באיות',
          skillVocabulary: 'ממוצע באוצר המילים',
          teacherNames: 'שם/שמות המורה/ים',
        },
        loadingData: 'טוען נתוני מיומנויות...',
        title: {
          AvgScores: 'ציונים ממוצעים ({{skill}} )',
          StudentsAcrossSkills: 'ביצועי תלמידים במיומנויות השונות ({{skill}} )',
        },
        totalStudents: '{{totalStudents}} תלמידים שהתחילו לשחק בסך הכול',
      },
      students: {
        allLevelsHint: 'הנתונים משקפים את ביצועי התלמידים בכל הרמות.',
        columns: {
          class: 'כיתה',
          completedActivities: 'פעילויות שהושלמו',
          currentLevel: 'רמה נוכחית',
          firstLogin: 'התחברות ראשונה',
          grade: 'שכבה',
          lastLogin: 'התחברות אחרונה',
          name: 'שם מלא של התלמיד/ה',
          nameAndTeacher: 'שם ומורה',
          progress: 'התקדמות',
          score: 'Score',
          startingLevel: 'רמת התחלה',
          teacherNames: 'שם/שמות המורה/ים',
          timeSpent: 'זמן ביצוע',
          totalActivities: 'סך כל הפעילויות',
        },
        levelHint: 'נתונים אלה לקוחים מכל הרמות',
        loadingData: 'טוען נתוני רמה...',
        notAvailable: 'לא קיים',
        subTitle: '*רמת ההתחלה שונתה על-ידי המורה.',
        title: {
          AvgStudentGrowth: 'גידול ממוצע במספר התלמידים',
          AvgStudentProgressAtCurrentLevel: 'התקדמות ממוצעת של תלמידים ברמה הנוכחית',
          StudentLevelProgression: 'התקדמות ברמת התלמידים',
        },
        totalStudents: '{{totalStudents}} תלמידים שהתחילו לשחק בסך הכול',
      },
    },
    emptyState: {
      filter: {
        description:
          'תלמידים שלא ניסו כלל במהלך פרק הזמן הזה אינם נכללים בחישוב האחוזים הממוצעים, אך נכללים במספר התלמידים הכולל ובקבוצות אחרות עבור סוגים אחרים של נתונים מצטברים רלוונטיים.',
        title: 'אין נתונים עבור פרק הזמן שנבחר',
      },
      global: {
        description: 'כאשר התלמידים יתחילו לשחק, מדדי הביצועים שלהם יופיעו כאן.',
        title: 'אין עדיין פעילות',
      },
    },
    exportData: {
      button: 'ייצוא נתונים',
      fileName: 'לוח מדדי התקדמות התלמידים',
      sheet: {
        levels: 'רמות',
        skills: 'מיומנות ({{skill}} )',
      },
    },
    filters: {
      completedActivities: 'פעילויות שהושלמו',
      currentLevel: 'רמה נוכחית',
      currentLevelSearchPlaceholder: 'חיפוש רמה',
      firstLogin: 'התחברות ראשונה',
      grade: 'שכבה',
      gradeSearchPlaceholder: 'חיפוש שכבה',
      group: 'שם הכיתה',
      groupSearchPlaceholder: 'חיפוש כיתה',
      lastLogin: 'התחברות אחרונה',
      startingLevel: 'רמת התחלה',
      startingLevelSearchPlaceholder: 'חיפוש רמה',
      studentName: 'שם התלמיד/ה',
      studentNameSearchPlaceholder: 'חיפוש תלמיד/ה',
      teacher: 'שם המורה',
      teacherSearchPlaceholder: 'חיפוש מורה',
      timeRange: 'טווח זמן',
      timeSpent: 'זמן ביצוע',
    },
    loadingMetrics: 'טוען מדדים...',
    pageTabs: {
      data: 'נתונים',
      metrics: 'מדדים',
    },
    totalStudents: 'סך הכול :{{totalStudents}} תלמידים שהתחילו לשחק',
  },
  studentName: 'שם',
  studentProfile: 'פרופיל תלמיד',
  studentReport: 'דו"ח על תלמיד',
  students: 'תלמידים',
  studentsContent: {
    levelHint: 'נתונים אלה מייצגים את הרמה הנוכחית',
  },
  subject: 'נושא',
  submit: 'שליחה',
  suggested_languages: 'שפות לבחירה',
  sundayShort: "א'",
  sync: 'סנכרון',
  syncDataDescription:
    'פעולה זו תסנכרן את ההבדל בנתונים בין Hello ל-Google Classroom, ותכלול את העדכונים האחרונים שבוצעו.',
  syncYourData: 'סנכרון הנתונים שלך',
  synonyms: 'מילים נרדפות',
  tapToSpeak: 'לחצו על סימן המיקרופון כדי לדבר',
  teacherInstructions: 'ההוראות למורה',
  teacherLetsBeginn: 'נתחיל!',
  teacherMobile: {
    classesMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    studentsMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    tutorMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
  },
  teacherName: 'שם המורה',
  teachers: 'מורות ומורים',
  teachersThatHaveRegistered: 'מורים שנרשמו',
  temporaryPassword: 'הסיסמה הזמנית:',
  termsAndConditions: 'תנאי השימוש',
  testYourEnglish: 'נבדוק את רמת האנגלית שלך',
  thankYou: 'תודה!',
  thanksForSubmission: 'תודה על מה שכתבת!',
  thats_the_way: 'יפה מאוד!',
  theAnswerIsIncorrectWhatWeHeardWas: 'תשובה לא נכונה, מה ששמענו היה:',
  thisStudentIsInactive:
    'התלמיד או התלמידה אינם במצב פעיל. הם הוזמנו לכיתה, אך טרם שינו את הסיסמה הזמנית שלהם וטרם התחילו את מבחן הרמה הראשוני.',
  thisStudentIsLevelTestIncomplete:
    'התלמיד או התלמידה עוד לא השלימו את מבחן הרמה הראשוני. לאחר השלמת המבחן תהיה לך אפשרות לראות את התקדמותם.',
  thisTopicWillHelpMe: 'הנושא הזה יעזור לי',
  thursdayShort: "ה'",
  timeIsUp: 'נגמר הזמן!',
  timeSpent: 'זמן ביצוע',
  tip: 'טיפ!',
  tipsAndTricks: 'טיפ',
  to: 'אל',
  toImproveYourVocabulary: 'כדי לשפר את אוצר המילים שלך,',
  toNextQuestion: 'לשאלה הבאה',
  toggle: 'החלפת מצב',
  topicProgress: 'התקדמות בנושא',
  topics: 'נושאים',
  totalActivities: 'סך כל הפעילויות',
  totalCoins: 'מטבעות',
  totalHintsUsed: 'מספר הרמזים',
  totalProgressWithinLevel: 'התקדמות כוללת בתוך הרמה',
  totalQuizzes: 'כל החידונים',
  totalTimeSpent: 'סך כל זמן הביצוע',
  totalTimeSpentTooltip: 'סך כל הזמן שהתלמידים שיחקו במהלכו באופן פעיל.',
  totalTimeSpent_mobile: 'סך כל זמן הביצוע',
  tries: 'ניסיונות',
  tryAgain: 'ניסיון חוזר',
  tryAgainBtn: 'ניסיון חוזר',
  tryAgainLater: 'יש לנסות שוב בהמשך',
  tryAgainOneMore: 'לנסות עוד פעם אחת או להמשיך הלאה',
  tryAgainOrKeepGoing: 'לנסות שוב או להמשיך',
  tryBetter: 'לא להתייאש, להמשיך לתרגל!',
  tryToGetAllStars: 'אפשר ללחוץ על שם הפעילות כדי לשפר את התוצאה ל-3 כוכבים!',
  tuesdayShort: "ג'",
  tutorBack: '< חזרה',
  tutorCorrectAnswerIsShort: 'התשובה הנכונה היא <strong> {{answer}} </strong>',
  tutorEndActivityBtn: 'End Activity',
  tutorEndConversationBtn: 'סיום השיחה',
  tutorNewConversation:
    '👋🏻 Hey {{name}}!\nYou\'re building <br class="desktop-br">stronger <span style="color: #05abf4" >grammar</span>\nand <span style="color: #ff9f4c">expression</span> skills!',
  tutorRouterPrompt: {
    activity: {
      cancelBtn: 'המשך',
      confirmBtn: 'סיום השיחה',
      description: 'אם ברצונך לסיים אותה, השיחה הזאת לא תישמר.',
      title: 'רוצה לסיים את השיחה?',
    },
    cancelBtn: 'Let’s Keep Talking',
    confirmBtn: 'End Conversation',
    description: 'If you end it now, this conversation will not be saved.',
    fromCanDoBeforeStarted: {
      cancelBtn: 'Continue with Tutor',
      confirmBtn: 'I’m sure',
      title: 'Are you sure you don’t want to review {{topicName}}?',
    },
    title: 'End the conversation?',
  },
  uncorrectPronounce: 'אפשר לנסות שוב או לדלג לשאלה הבאה.',
  understandingYourEnglishLevel: 'אנו מתחילים להבין את רמת האנגלית שלך.',
  unfortunately: 'למרבה הצער לא עברת, לכן לא קיבלת מטבעות על החידון הזה.',
  university: 'אוניברסיטה',
  update: 'עדכון',
  uploadCsvErrorModalDescription: 'ייתכן שיש בעיה בחיבור האינטרנט. <br />נא לנסות שוב.',
  uploadCsvErrorModalTitle: 'ההעלאה נכשלה',
  useTheCoins: 'אפשר להשתמש במטבעות שהרווחת כדי לקבל עזרה',
  userDataSuccessfullyUpdated:
    'הפרטים עודכנו בהצלחה. נא לבקש מהתלמיד/ה להתנתק ולהתחבר מחדש כדי לראות את השינויים.\n',
  userStreak: {
    subTitle: 'מומלץ לתרגל כל יום כדי להיות מומחים',
    title: 'כדאי לשמור על הרצף!',
  },
  username: 'שם משתמש',
  usernameAlreadyExists: 'שם המשתמש הזה כבר תפוס',
  usernameTooLong: 'שם המשתמש ארוך מדי',
  usingYourMicrophone: 'יש לדבר לאט וברור אל המיקרופון, ולוודא שאין רעשי רקע.',
  validation: {
    code_required: 'קוד נדרש',
    confirm_password_required: 'יש לאשר את הסיסמה',
    email_required: 'יש להכניס כתובת מייל',
    password_required: 'יש להזין סיסמה',
    username_or_email_required: 'יש להזין שם משתמש או דוא"ל',
  },
  validationCodeInvalid: 'קוד האימות אינו תקין',
  verificationCode: 'קוד אימות',
  verificationCodeResentCheckEmail:
    'A new verification code was sent to your email. Enter the latest code below.',
  verificationCodeSent: 'קוד אימות נשלח אל',
  viewAnswerChoices: 'צפייה באפשרויות התשובה',
  vocabulary_tip: 'טיפ באוצר מילים',
  waitingForStudentsDescription: 'יתאפשר לך לראות אותם מייד אחרי שהם יירשמו לפלטפורמה!',
  waitingForStudentsToJoin: 'מחכים שהתלמידים שלך יצטרפו!',
  warningTemporaryPassword: 'לידיעתך, הסיסמה הזמנית תהיה בתוקף למשך 7 ימים!',
  weAreAnalyzing: 'אנחנו מנתחים את מה שכתבת. רק כמה רגעים...',
  weCouldNotProduce: 'לא יכולנו להפיק את הדו"ח כרגע.',
  weStillDontHaveAll: 'עדיין חסר לנו כל המידע הדרוש, או שיש תקלה זמנית.',
  we_want_to_know: 'אנחנו רוצים לדעת את הרמה שלך',
  wednesdayShort: "ד'",
  welcome: 'ברוך בואך',
  welcomeConfetti: 'ברוך בואך',
  welcomeTo: 'ברוך בואך אל',
  wellDone: 'כל הכבוד',
  wordCount: 'ספירת מילים: {{wordCount}}',
  words: 'ללמוד אנגלית',
  wordsList: 'רשימת מילים',
  wow: 'איזה יופי',
  wow_score_all_stars: 'איזה יופי, קיבלת ציון <b>{{score}} </b> והשגת את כל הכוכבים.',
  writeClassNameHere: 'נא לכתוב את שם הכיתה',
  writeHere: 'לכתוב כאן',
  writeOrSay: 'כאן אפשר לכתוב או להגיד את התגובה שלך...',
  wrongAnswer: 'תשובה שגויה!',
  yes: 'כן',
  yesDelete: 'כן, למחוק',
  youAlmostThere: 'עוד קצת וסיימת...',
  youAreDoingGreatLetsKeepGoing: 'התקדמת יפה! <br/>בואו נמשיך.',
  youAreOnYourWay: 'ממשיכים בחידון!',
  youCanCreateMore: 'אפשר ליצור יותר מכיתה אחת',
  youCanPractice: 'אפשר לשחק בחידון או לתרגל את רשימת המילים בעזרת כרטיסיות.',
  youHaveCompleted: 'השלמת את הנושא!',
  youMayNowShare: 'כעת אפשר לשתף את הקישור עם ',
  youPassedTheQuiz: 'עברת את הפעילות בציון <b>{{score}} </b> ! <br/> יפה מאוד!',
  youPracticed: 'תרגלת ולמדת.',
  youWillLose: 'אחרת לא יישמרו לך',
  you_did_it: 'הצלחת!',
  you_got_a_score_try_again:
    'הפעם קיבלת ציון <b>{{score}} </b>. אפשר לנסות שוב אחר כך כדי להשיג עוד כוכבים.',
  you_got_no_extra_stars: 'קיבלת <b>{{score}}</b> שוב.',
  your: 'שלך',
  yourClasses: 'כיתות',
  yourMessageHasBeenSentSuccessfully: 'ההודעה נשלחה בהצלחה. תודה שהקדשת זמן כדי לפנות אלינו!',
  yourMessageHere: 'תוכן ההודעה',
  yourPasswordHere: 'הסיסמה שלך',
  yourPhoneHere: 'מספר הטלפון שלך',
  yourSchoolHasBeenCreated: 'בית הספר נוצר בהצלחה',
  yourStreak: 'רצף התרגול שלך',
  yourStudentQuiz:
    'זהו המבחן שהתלמידים שלך יעברו אחרי שהם יתחברו בפעם הראשונה. אפשר לנסות אותו בעצמך עכשיו או מאוחר יותר.',
  yourStudentsHaveNotJoined: 'עדיין אין תלמידים פעילים',
  yourSubjectHere: 'נושא הפנייה',
};
